export const data = { content:"{\"openapi\":\"3.1.1\",\"info\":{\"title\":\"API- Berkley Europe\",\"version\":\"2.0.0\"},\"paths\":{\"/api/affinities/CreateQuote\":{\"post\":{\"tags\":[\"Quotes\"],\"summary\":\"Creates a quote from an input object. Returns the quote ID and premium values\",\"parameters\":[{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"requestBody\":{\"description\":\"\",\"content\":{\"application/json-patch+json\":{\"schema\":{\"$ref\":\"#/components/schemas/QuotePostDTO\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/QuotePostDTO\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/QuotePostDTO\"}},\"application/*+json\":{\"schema\":{\"$ref\":\"#/components/schemas/QuotePostDTO\"}}}},\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/CreateQuoteAffinitiesResponseDTOResponseAffinities\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CreateQuoteAffinitiesResponseDTOResponseAffinities\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CreateQuoteAffinitiesResponseDTOResponseAffinities\"}}}}}}},\"/api/affinities/IssuePolicy\":{\"post\":{\"tags\":[\"Policies\"],\"summary\":\"Issues a policy based on the quote ID. Asynchronously sends the policy to be digitally signed\",\"parameters\":[{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"requestBody\":{\"description\":\"\",\"content\":{\"application/json-patch+json\":{\"schema\":{\"$ref\":\"#/components/schemas/IssuePolicyPostDTO\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/IssuePolicyPostDTO\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/IssuePolicyPostDTO\"}},\"application/*+json\":{\"schema\":{\"$ref\":\"#/components/schemas/IssuePolicyPostDTO\"}}}},\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/PolicyResponseDTOResponseAffinities\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/PolicyResponseDTOResponseAffinities\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/PolicyResponseDTOResponseAffinities\"}}}}}}},\"/api/affinities/UpdateDigitalSignatureStatus\":{\"put\":{\"tags\":[\"Documentation\"],\"summary\":\"Checks and updates the status of a digital signature. Upon completion, sends the signed policy to the broker.\",\"parameters\":[{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"requestBody\":{\"description\":\"\",\"content\":{\"application/json-patch+json\":{\"schema\":{\"$ref\":\"#/components/schemas/QuoteIdentificationAffinitiesDTO\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/QuoteIdentificationAffinitiesDTO\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/QuoteIdentificationAffinitiesDTO\"}},\"application/*+json\":{\"schema\":{\"$ref\":\"#/components/schemas/QuoteIdentificationAffinitiesDTO\"}}}},\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/UpdateDigitalSignResponseDTOResponseAffinities\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/UpdateDigitalSignResponseDTOResponseAffinities\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/UpdateDigitalSignResponseDTOResponseAffinities\"}}}}}}},\"/api/affinities/GenerateDocument\":{\"post\":{\"tags\":[\"Documentation\"],\"summary\":\"Generates a document for a given quote and document type.\",\"parameters\":[{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"requestBody\":{\"description\":\"\",\"content\":{\"application/json-patch+json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentRequestDTO\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentRequestDTO\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentRequestDTO\"}},\"application/*+json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentRequestDTO\"}}}},\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities\"}}}}}}},\"/api/affinities/DownloadDocument\":{\"post\":{\"tags\":[\"Documentation\"],\"summary\":\"Downloads a document for a given quote and document type.\",\"parameters\":[{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"requestBody\":{\"description\":\"\",\"content\":{\"application/json-patch+json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentRequestDTO\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentRequestDTO\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentRequestDTO\"}},\"application/*+json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentRequestDTO\"}}}},\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities\"}}}}}}},\"/api/affinities/GetProductConfiguration\":{\"get\":{\"tags\":[\"Products\"],\"summary\":\"Returns the configuration for a given product\",\"parameters\":[{\"name\":\"product\",\"in\":\"query\",\"description\":\"\",\"schema\":{\"type\":\"string\"}},{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/ProductConfigurationDTOResponseAffinities\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/ProductConfigurationDTOResponseAffinities\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/ProductConfigurationDTOResponseAffinities\"}}}}}}},\"/api/underwriting/CreateRequest\":{\"post\":{\"tags\":[\"Quotes\"],\"summary\":\"Create a new request based on input data. Returns Quote IDs for later update.\",\"parameters\":[{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"requestBody\":{\"description\":\"\",\"content\":{\"application/json-patch+json\":{\"schema\":{\"$ref\":\"#/components/schemas/CreateRequestDTO\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CreateRequestDTO\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CreateRequestDTO\"}},\"application/*+json\":{\"schema\":{\"$ref\":\"#/components/schemas/CreateRequestDTO\"}}}},\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/ResponseCreateRequestUnderwritingDTOResponseUnderwriting\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/ResponseCreateRequestUnderwritingDTOResponseUnderwriting\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/ResponseCreateRequestUnderwritingDTOResponseUnderwriting\"}}}}}}},\"/api/underwriting/SaveQuote\":{\"post\":{\"tags\":[\"Quotes\"],\"summary\":\"Update a quote based on the input data. Returns Quote IDs and premium values.\",\"parameters\":[{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"requestBody\":{\"description\":\"\",\"content\":{\"application/json-patch+json\":{\"schema\":{\"$ref\":\"#/components/schemas/SaveQuoteDTO\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/SaveQuoteDTO\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/SaveQuoteDTO\"}},\"application/*+json\":{\"schema\":{\"$ref\":\"#/components/schemas/SaveQuoteDTO\"}}}},\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/ResponseSaveQuoteUnderwritingDTOResponseUnderwriting\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/ResponseSaveQuoteUnderwritingDTOResponseUnderwriting\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/ResponseSaveQuoteUnderwritingDTOResponseUnderwriting\"}}}}}}},\"/api/underwriting/GetExampleToSaveQuote\":{\"get\":{\"tags\":[\"Quotes\"],\"summary\":\"Get an example object to SaveQuote endpoint. Only from quotes modified by the user.\",\"parameters\":[{\"name\":\"quoteID\",\"in\":\"query\",\"description\":\"\",\"schema\":{\"type\":\"integer\",\"format\":\"int32\"}},{\"name\":\"quoteNumber\",\"in\":\"query\",\"description\":\"\",\"schema\":{\"type\":\"integer\",\"format\":\"int32\"}},{\"name\":\"X-Branch\",\"in\":\"header\"},{\"name\":\"X-ApiKey\",\"in\":\"header\"},{\"name\":\"X-Version\",\"in\":\"header\"}],\"responses\":{\"200\":{\"description\":\"OK\",\"content\":{\"text/plain\":{\"schema\":{\"$ref\":\"#/components/schemas/SaveQuoteDTOResponseUnderwriting\"}},\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/SaveQuoteDTOResponseUnderwriting\"}},\"text/json\":{\"schema\":{\"$ref\":\"#/components/schemas/SaveQuoteDTOResponseUnderwriting\"}}}}}}}},\"components\":{\"schemas\":{\"ActivateButtonsResultDTO\":{\"type\":\"object\",\"properties\":{\"informacionControles\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ControlInformation\"}},\"changeDates\":{\"$ref\":\"#/components/schemas/ChangeDateDTO\"},\"premiumControlList\":{\"$ref\":\"#/components/schemas/PremiumControlList\"}},\"additionalProperties\":false},\"ActivateButtonsResultDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/ActivateButtonsResultDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"ActuarialPricingFormula\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"integer\",\"format\":\"int32\"},\"producto\":{\"type\":[\"string\",\"null\"]},\"formula\":{\"type\":[\"string\",\"null\"]},\"autoCalculation\":{\"type\":\"boolean\"},\"f_Modif\":{\"type\":\"string\",\"format\":\"date-time\"},\"usr_Modif\":{\"type\":[\"string\",\"null\"]},\"observaciones\":{\"type\":[\"string\",\"null\"]},\"f_Version\":{\"type\":\"string\",\"format\":\"date-time\"}},\"additionalProperties\":false},\"Adm_UsuariosDTO\":{\"type\":\"object\",\"properties\":{\"usuario\":{\"type\":[\"string\",\"null\"]},\"idioma\":{\"type\":[\"string\",\"null\"]},\"dni\":{\"type\":[\"string\",\"null\"]},\"filtro_poliza\":{\"type\":[\"string\",\"null\"]},\"filtro_Corredor\":{\"type\":[\"string\",\"null\"]},\"suscriptor\":{\"type\":[\"string\",\"null\"]},\"nivelSeguridad\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"}},\"additionalProperties\":false},\"AlertValidatableWarning\":{\"type\":\"object\",\"properties\":{\"alertType\":{\"type\":[\"string\",\"null\"]},\"alertId\":{\"type\":[\"string\",\"null\"]},\"errorMessage\":{\"$ref\":\"#/components/schemas/ErrorMessage\"}},\"additionalProperties\":false},\"AlertasCotizaciones\":{\"type\":\"object\",\"properties\":{\"iD_Cot\":{\"type\":\"integer\",\"format\":\"int32\"},\"nivel\":{\"type\":\"integer\",\"format\":\"int32\"},\"alerta\":{\"type\":[\"string\",\"null\"]},\"responsable\":{\"type\":[\"string\",\"null\"]},\"poliza\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"fechaSolicitud\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"loB\":{\"type\":[\"string\",\"null\"]},\"cliente\":{\"type\":[\"string\",\"null\"]},\"corredor\":{\"type\":[\"string\",\"null\"]},\"oficina\":{\"type\":[\"string\",\"null\"]},\"suscriptor\":{\"type\":[\"string\",\"null\"]},\"estado\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"capital\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"prima\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comision\":{\"type\":[\"number\",\"null\"],\"format\":\"float\"},\"validable\":{\"type\":\"boolean\"},\"info\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"AuditDTO\":{\"type\":\"object\",\"properties\":{\"iD_Log\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"usuarioSolicita\":{\"type\":[\"string\",\"null\"]},\"usuarioUltimaModificacion\":{\"type\":[\"string\",\"null\"]},\"usuarioModificacion\":{\"type\":[\"string\",\"null\"]},\"usuarioComercial\":{\"type\":[\"string\",\"null\"]},\"usuarioAprobacion\":{\"type\":[\"string\",\"null\"]},\"fechaModificacion\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"necesitaAutorizacion\":{\"type\":\"boolean\"},\"permisosAdministrador\":{\"type\":\"boolean\"}},\"additionalProperties\":false},\"AuthorizationResponseDTO\":{\"type\":\"object\",\"properties\":{\"resultado\":{\"type\":\"boolean\"},\"mensajePopup\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"AuthorizationResponseDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/AuthorizationResponseDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"Automatic_Process_ServicesDTO\":{\"type\":\"object\",\"properties\":{\"action\":{\"type\":[\"string\",\"null\"]},\"name\":{\"type\":[\"string\",\"null\"]},\"value\":{\"type\":[\"string\",\"null\"]},\"suscriptor\":{\"type\":[\"string\",\"null\"]},\"tipo\":{\"type\":[\"string\",\"null\"]},\"patron\":{\"type\":[\"string\",\"null\"]},\"mensaje\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Comerciales\":{\"type\":\"object\",\"properties\":{\"valor\":{\"type\":[\"string\",\"null\"]},\"descripcion\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Corredores\":{\"type\":\"object\",\"properties\":{\"nombre_Largo\":{\"type\":[\"string\",\"null\"]},\"nombre\":{\"type\":[\"string\",\"null\"]},\"domicilio\":{\"type\":[\"string\",\"null\"]},\"cod_Postal\":{\"type\":[\"string\",\"null\"]},\"telefono_1\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"localidad\":{\"type\":[\"string\",\"null\"]},\"id\":{\"type\":[\"string\",\"null\"]},\"autorizadoDGS\":{\"type\":\"boolean\"},\"autorizadoASF\":{\"type\":\"boolean\"},\"id_Estado\":{\"type\":[\"string\",\"null\"]},\"especial\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Entidades\":{\"type\":\"object\",\"properties\":{\"cod\":{\"type\":\"integer\",\"format\":\"int32\"},\"tipo\":{\"type\":[\"string\",\"null\"]},\"entidad\":{\"type\":[\"string\",\"null\"]},\"nombreLargo\":{\"type\":[\"string\",\"null\"]},\"cif\":{\"type\":[\"string\",\"null\"]},\"contacto\":{\"type\":[\"string\",\"null\"]},\"telefono\":{\"type\":[\"string\",\"null\"]},\"fax\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"direccion1\":{\"type\":[\"string\",\"null\"]},\"direccion2\":{\"type\":[\"string\",\"null\"]},\"direccion3\":{\"type\":[\"string\",\"null\"]},\"envioConsorcio\":{\"type\":[\"boolean\",\"null\"]},\"iban\":{\"type\":[\"string\",\"null\"]},\"ccc\":{\"type\":[\"string\",\"null\"]},\"emailCC\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_IndustryCode\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"integer\",\"format\":\"int32\"},\"code\":{\"type\":[\"string\",\"null\"]},\"descripcion\":{\"type\":[\"string\",\"null\"]},\"levelId\":{\"type\":\"integer\",\"format\":\"int32\"}},\"additionalProperties\":false},\"Aux_Legal_Entities\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"integer\",\"format\":\"int32\"},\"nombre\":{\"type\":[\"string\",\"null\"]},\"nombre_Largo\":{\"type\":[\"string\",\"null\"]},\"descripcion\":{\"type\":[\"string\",\"null\"]},\"moneda_Defecto\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Listas\":{\"type\":\"object\",\"properties\":{\"lista\":{\"type\":[\"string\",\"null\"]},\"orden\":{\"type\":\"integer\",\"format\":\"int32\"},\"valor\":{\"type\":[\"string\",\"null\"]},\"descripcion\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Listas_WithName\":{\"type\":\"object\",\"properties\":{\"nombre\":{\"type\":[\"string\",\"null\"]},\"lista\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Listas\"}}},\"additionalProperties\":false},\"Aux_Localidades\":{\"type\":\"object\",\"properties\":{\"nombre\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Motivos_Suplementos\":{\"type\":\"object\",\"properties\":{\"codigo\":{\"type\":[\"string\",\"null\"]},\"descripcion\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Oficinas\":{\"type\":\"object\",\"properties\":{\"siglas\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Oficinas_Corredor\":{\"type\":\"object\",\"properties\":{\"registro_cia\":{\"type\":[\"string\",\"null\"]},\"oficina\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Paises\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":[\"string\",\"null\"]},\"nombre\":{\"type\":[\"string\",\"null\"]},\"orden\":{\"type\":\"integer\",\"format\":\"int32\"}},\"additionalProperties\":false},\"Aux_Profit_Centers\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"integer\",\"format\":\"int32\"},\"nombre\":{\"type\":[\"string\",\"null\"]},\"nombre_Largo\":{\"type\":[\"string\",\"null\"]},\"descripcion\":{\"type\":[\"string\",\"null\"]},\"cia\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Suscriptores\":{\"type\":\"object\",\"properties\":{\"codigo\":{\"type\":[\"string\",\"null\"]},\"nombre\":{\"type\":[\"string\",\"null\"]},\"codigo2\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"codigo3\":{\"type\":[\"string\",\"null\"]},\"titulo\":{\"type\":[\"string\",\"null\"]},\"telefono\":{\"type\":[\"string\",\"null\"]},\"movil\":{\"type\":[\"string\",\"null\"]},\"paginaWeb\":{\"type\":[\"string\",\"null\"]},\"direccion\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Aux_Zona_Corredores\":{\"type\":\"object\",\"properties\":{\"zona\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"AuxiliarData\":{\"type\":\"object\",\"properties\":{\"n_CotizacionOrigen\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"modoPagina\":{\"type\":[\"string\",\"null\"]},\"emitiendo\":{\"type\":\"boolean\"},\"conCorredorSecundario\":{\"type\":\"boolean\"},\"corredorSecundarioCodigoControl\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"capitalControl\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"agregadoControl\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"accion\":{\"type\":[\"string\",\"null\"]},\"siniestrosAbiertos\":{\"type\":\"boolean\"},\"databaseAlerts\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/AlertasCotizaciones\"}},\"languageTo\":{\"type\":[\"string\",\"null\"]},\"appName\":{\"type\":[\"string\",\"null\"]},\"textoSuplementoTraducido\":{\"type\":[\"string\",\"null\"]},\"brokerDataControl\":{\"$ref\":\"#/components/schemas/BrokerDataForQuoteValidation\"},\"cantidadPolizasControl\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"estadoActualEnBase\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"estadoCodigo\":{\"type\":[\"string\",\"null\"]},\"estadoDescripcion\":{\"type\":[\"string\",\"null\"]},\"defaultCurrency\":{\"type\":[\"string\",\"null\"]},\"quoteTitle\":{\"type\":[\"string\",\"null\"]},\"n_CotizacionEmision\":{\"type\":\"integer\",\"format\":\"int32\"},\"suplementoRenovableVisible\":{\"type\":\"boolean\"},\"cambioPorComplexPricing\":{\"type\":\"boolean\"},\"pantallaOrigen\":{\"type\":[\"string\",\"null\"]},\"hostOrigen\":{\"type\":[\"string\",\"null\"]},\"iD_Risk\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"aptoParaFirmaDigital\":{\"type\":\"boolean\"},\"cambioPorTipoCalculoReciboAdaptado\":{\"type\":\"boolean\"},\"autorizacionesNT\":{\"type\":[\"string\",\"null\"]},\"usuarioAutoriza\":{\"type\":[\"string\",\"null\"]},\"usuarioAutorizaTexto\":{\"type\":[\"string\",\"null\"]},\"motivoSuplementoTexto\":{\"type\":[\"string\",\"null\"]},\"productoDescripcion\":{\"type\":[\"string\",\"null\"]},\"actividadTexto\":{\"type\":[\"string\",\"null\"]},\"idCompaniaBerkley\":{\"type\":\"integer\",\"format\":\"int32\"}},\"additionalProperties\":false},\"BooleanResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"boolean\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"BrokerDataForQuoteValidation\":{\"type\":\"object\",\"properties\":{\"autorizadoDGS\":{\"type\":\"boolean\"},\"autorizadoASF\":{\"type\":\"boolean\"},\"idEstado\":{\"type\":[\"string\",\"null\"]},\"especial\":{\"type\":\"boolean\"}},\"additionalProperties\":false},\"ChangeDateDTO\":{\"type\":\"object\",\"properties\":{\"fechaInicio\":{\"type\":\"string\",\"format\":\"date-time\"},\"horaInicio\":{\"type\":[\"string\",\"null\"]},\"fechaVencimiento\":{\"type\":\"string\",\"format\":\"date-time\"},\"horaVencimiento\":{\"type\":[\"string\",\"null\"]},\"fechaRetro\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"}},\"additionalProperties\":false},\"ClientPostDTO\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":[\"string\",\"null\"]},\"tin\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"phone\":{\"type\":[\"string\",\"null\"]},\"address\":{\"type\":[\"string\",\"null\"]},\"city\":{\"type\":[\"string\",\"null\"]},\"postalCode\":{\"type\":[\"string\",\"null\"]},\"province\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"CoinsuranceDetailDTO\":{\"type\":\"object\",\"properties\":{\"polizaAbridora\":{\"type\":[\"string\",\"null\"]},\"impuestosLiquidos\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comisionLiquida\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaLiquida\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"participacion\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comisionAdministracion\":{\"type\":[\"number\",\"null\"],\"format\":\"float\"},\"distribution\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/CoinsuranceDistributionDTO\"}}},\"additionalProperties\":false},\"CoinsuranceDistributionDTO\":{\"type\":\"object\",\"properties\":{\"compania\":{\"type\":\"integer\",\"format\":\"int32\"},\"iD_Ctto\":{\"type\":\"integer\",\"format\":\"int32\"},\"lider\":{\"type\":\"boolean\"},\"part_Cia\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comision\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"entidad\":{\"type\":[\"string\",\"null\"]},\"entidadDescripcion\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"ComboCorredorDTO\":{\"type\":\"object\",\"properties\":{\"toolTip\":{\"type\":[\"array\",\"null\"],\"items\":{\"type\":\"string\"}},\"oficinasCorredores\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Oficinas_Corredor\"}},\"zonaCorredores\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Zona_Corredores\"}},\"comerciales\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Comerciales\"}}},\"additionalProperties\":false},\"ComboCorredorDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/ComboCorredorDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"Common_Functions_ServicesDTO\":{\"type\":\"object\",\"properties\":{\"action\":{\"type\":[\"string\",\"null\"]},\"name\":{\"type\":[\"string\",\"null\"]},\"value\":{\"type\":[\"string\",\"null\"]},\"mensaje\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"ControlInformation\":{\"type\":\"object\",\"properties\":{\"selector\":{\"type\":[\"string\",\"null\"]},\"text\":{\"type\":[\"string\",\"null\"]},\"visible\":{\"type\":[\"boolean\",\"null\"]},\"enabled\":{\"type\":[\"boolean\",\"null\"]},\"placeholder\":{\"type\":[\"string\",\"null\"]},\"listName\":{\"type\":[\"string\",\"null\"]},\"onClick\":{\"type\":[\"string\",\"null\"]},\"value\":{\"type\":[\"string\",\"null\"]},\"valueDate\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"href\":{\"type\":[\"string\",\"null\"]},\"dataType\":{\"type\":[\"string\",\"null\"]},\"listItems\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/SelectListItem\"}}},\"additionalProperties\":false},\"ControlInformationIEnumerableResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ControlInformation\"}},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"ControladorQueryDTO\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":[\"string\",\"null\"]},\"codigo\":{\"type\":[\"string\",\"null\"]},\"sql\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"ControladorQueryRespuestaDTO\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":[\"string\",\"null\"]},\"codigo\":{\"type\":[\"string\",\"null\"]},\"sqL_Original\":{\"type\":[\"string\",\"null\"]},\"respuesta\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"ControladorQueryRespuestaDTOIEnumerableResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ControladorQueryRespuestaDTO\"}},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"Coverage\":{\"type\":\"object\",\"properties\":{\"cobertura\":{\"type\":[\"string\",\"null\"]},\"limite\":{\"type\":[\"string\",\"null\"]},\"codigo\":{\"type\":[\"string\",\"null\"]},\"orden\":{\"type\":\"integer\",\"format\":\"int32\"},\"coverageDescription\":{\"type\":[\"string\",\"null\"]},\"limitDescription\":{\"type\":[\"string\",\"null\"]},\"tipo\":{\"type\":[\"string\",\"null\"]},\"coverageType\":{\"$ref\":\"#/components/schemas/CoverageTypeEnum\"},\"fieldType\":{\"$ref\":\"#/components/schemas/FieldTypeEnum\"},\"unidades\":{\"type\":[\"string\",\"null\"]},\"valor\":{\"type\":[\"string\",\"null\"]},\"valores\":{\"type\":[\"string\",\"null\"]},\"exceedsMain\":{\"type\":\"boolean\"},\"isOptional\":{\"type\":\"boolean\"},\"isFixed\":{\"type\":\"boolean\"},\"isCapital\":{\"type\":\"boolean\"},\"isPrincipal\":{\"type\":\"boolean\"},\"multiRisk\":{\"type\":\"boolean\"},\"formula\":{\"type\":[\"string\",\"null\"]},\"tipo_Campo\":{\"type\":[\"string\",\"null\"]},\"porDefecto\":{\"type\":[\"string\",\"null\"]},\"tipoCob\":{\"type\":[\"string\",\"null\"]},\"esVisible\":{\"type\":[\"string\",\"null\"]},\"tipoRiesgo\":{\"type\":\"integer\",\"format\":\"int32\"},\"rateIncrease\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"CoverageAnswerDTO\":{\"type\":\"object\",\"properties\":{\"cobertura\":{\"type\":[\"string\",\"null\"]},\"limite\":{\"type\":[\"string\",\"null\"]},\"codigo\":{\"type\":[\"string\",\"null\"]},\"respuesta\":{\"type\":[\"string\",\"null\"]},\"tipoCampo\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"CoverageResponseDTO\":{\"type\":\"object\",\"properties\":{\"order\":{\"type\":\"integer\",\"format\":\"int32\"},\"coverageDescription\":{\"type\":[\"string\",\"null\"]},\"limitDescription\":{\"type\":[\"string\",\"null\"]},\"value\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"CoverageTypeEnum\":{\"enum\":[0,1,2,3,4,5,6,7],\"type\":\"integer\",\"format\":\"int32\"},\"CreateQuoteAffinitiesResponseDTO\":{\"type\":\"object\",\"properties\":{\"quoteId\":{\"type\":[\"string\",\"null\"]},\"quoteNumber\":{\"type\":[\"string\",\"null\"]},\"premiumDetail\":{\"$ref\":\"#/components/schemas/PremiumResponseDTO\"},\"coverages\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/CoverageResponseDTO\"}},\"errors\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"CreateQuoteAffinitiesResponseDTOResponseAffinities\":{\"type\":\"object\",\"properties\":{\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"data\":{\"$ref\":\"#/components/schemas/CreateQuoteAffinitiesResponseDTO\"},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModelAffinities\"}},\"additionalProperties\":false},\"CreateRequestDTO\":{\"type\":\"object\",\"properties\":{\"detail\":{\"$ref\":\"#/components/schemas/CreateRequestDetailDTO\"},\"policyHolder\":{\"$ref\":\"#/components/schemas/SaveQuotePolicyholderDTO\"}},\"additionalProperties\":false},\"CreateRequestDetailDTO\":{\"type\":\"object\",\"properties\":{\"loB\":{\"type\":[\"string\",\"null\"]},\"productCode\":{\"type\":[\"string\",\"null\"]},\"riskSubtypeActivityCode\":{\"type\":\"integer\",\"format\":\"int32\"},\"activityCode\":{\"type\":[\"string\",\"null\"]},\"package\":{\"type\":[\"string\",\"null\"]},\"brokerCode\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"brokerEmail\":{\"type\":[\"string\",\"null\"]},\"brokerContact\":{\"type\":[\"string\",\"null\"]},\"underwriter\":{\"type\":[\"string\",\"null\"]},\"canal\":{\"type\":[\"string\",\"null\"]},\"legalEntity\":{\"type\":\"integer\",\"format\":\"int32\"},\"profitCenter\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"office\":{\"type\":[\"string\",\"null\"]},\"officeBrokerCode\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"industryCodeID\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"originalCurrency\":{\"type\":[\"string\",\"null\"]},\"brokerAgreementID\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"bussinessType\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"CredentialsDTO\":{\"required\":[\"password\",\"userName\"],\"type\":\"object\",\"properties\":{\"userName\":{\"minLength\":1,\"type\":\"string\"},\"password\":{\"minLength\":1,\"type\":\"string\"}},\"additionalProperties\":false},\"Currency\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":[\"string\",\"null\"]},\"nombre\":{\"type\":[\"string\",\"null\"]},\"defaultValue\":{\"type\":\"boolean\"}},\"additionalProperties\":false},\"DecimalDateTimeTuple\":{\"type\":\"object\",\"properties\":{\"item1\":{\"type\":\"number\",\"format\":\"double\"},\"item2\":{\"type\":\"string\",\"format\":\"date-time\"}},\"additionalProperties\":false},\"DecimalDateTimeTupleResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/DecimalDateTimeTuple\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"DocumentManagementPostDTO\":{\"type\":\"object\",\"properties\":{\"generateDocument\":{\"type\":\"boolean\"},\"sendingMethod\":{\"type\":[\"string\",\"null\"]},\"sendingAddress\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"DocumentatinDTO\":{\"type\":\"object\",\"properties\":{\"iD_Cot\":{\"type\":\"integer\",\"format\":\"int32\"},\"n_Cotizacion\":{\"type\":\"integer\",\"format\":\"int32\"},\"clausulaAclaratoria\":{\"type\":[\"string\",\"null\"]},\"condicionesEspeciales\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"fechaCondicionesEspeciales\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"condicionesGenerales\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"fechaCondicionesGenerales\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"listadoAsegurados\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"fechaListadoAsegurados\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"}},\"additionalProperties\":false},\"ErrorCodeEnum\":{\"enum\":[1,2,3,4,5,6,7,8,9],\"type\":\"integer\",\"format\":\"int32\"},\"ErrorMessage\":{\"type\":\"object\",\"properties\":{\"type\":{\"$ref\":\"#/components/schemas/ErrorType\"},\"message\":{\"type\":[\"string\",\"null\"]},\"messageTranslation\":{\"$ref\":\"#/components/schemas/TranslatedString\"},\"messageParameters\":{\"type\":[\"array\",\"null\"],\"items\":{\"type\":\"string\"}},\"errorServer\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"ErrorModel\":{\"type\":\"object\",\"properties\":{\"warnings\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/WarningMessage\"}},\"alertValidatables\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/AlertValidatableWarning\"}},\"errors\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ErrorMessage\"}},\"isValid\":{\"type\":\"boolean\",\"readOnly\":true},\"errorCode\":{\"$ref\":\"#/components/schemas/ErrorCodeEnum\"}},\"additionalProperties\":false},\"ErrorModelAffinities\":{\"type\":\"object\",\"properties\":{\"isValid\":{\"type\":\"boolean\",\"readOnly\":true},\"warnings\":{\"type\":[\"array\",\"null\"],\"items\":{\"type\":\"string\"}},\"errors\":{\"type\":[\"array\",\"null\"],\"items\":{\"type\":\"string\"}},\"htmlFormat\":{\"type\":[\"string\",\"null\"],\"readOnly\":true}},\"additionalProperties\":false},\"ErrorModelUnderwriting\":{\"type\":\"object\",\"properties\":{\"isValid\":{\"type\":\"boolean\",\"readOnly\":true},\"warnings\":{\"type\":[\"array\",\"null\"],\"items\":{\"type\":\"string\"}},\"errors\":{\"type\":[\"array\",\"null\"],\"items\":{\"type\":\"string\"}},\"htmlFormat\":{\"type\":[\"string\",\"null\"],\"readOnly\":true}},\"additionalProperties\":false},\"ErrorType\":{\"enum\":[0,1],\"type\":\"integer\",\"format\":\"int32\"},\"ExpositionDTO\":{\"type\":\"object\",\"properties\":{\"capital\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"isCapitalEdit\":{\"type\":\"boolean\"},\"agregado\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"isAgregadoEdit\":{\"type\":\"boolean\"},\"isAgregadoView\":{\"type\":\"boolean\"},\"limitePorVictima\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"}},\"additionalProperties\":false},\"FieldTypeEnum\":{\"enum\":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],\"type\":\"integer\",\"format\":\"int32\"},\"GenerateDocumentRequestDTO\":{\"type\":\"object\",\"properties\":{\"quoteIdentification\":{\"$ref\":\"#/components/schemas/QuoteIdentificationAffinitiesDTO\"},\"docType\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"GenerateDocumentResponseDTO\":{\"type\":\"object\",\"properties\":{\"document\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"GenerateDocumentResponseDTOResponseAffinities\":{\"type\":\"object\",\"properties\":{\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"data\":{\"$ref\":\"#/components/schemas/GenerateDocumentResponseDTO\"},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModelAffinities\"}},\"additionalProperties\":false},\"HealthStatusEnum\":{\"enum\":[0,1,2],\"type\":\"integer\",\"format\":\"int32\"},\"HealthStatusEnumResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/HealthStatusEnum\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"InitialDataForBeitsPageDTO\":{\"type\":\"object\",\"properties\":{\"quoteInitialData\":{\"$ref\":\"#/components/schemas/QuoteInitialDataDTO\"},\"producto\":{\"$ref\":\"#/components/schemas/Product\"},\"coberturasOpcionales\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/OptionalCoverage\"}},\"validaciones\":{\"$ref\":\"#/components/schemas/QuoteAlertsDTO\"},\"informacionControles\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ControlInformation\"}},\"paises\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Paises\"}},\"vismaPaises\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Paises\"}},\"corredores\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Corredores\"}},\"corredoresGrupoCOS\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Corredores\"}},\"profitCenters\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Profit_Centers\"}},\"legalEntities\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Legal_Entities\"}},\"monedas\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Currency\"}},\"oficinas\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Oficinas\"}},\"motivosSuplementos\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Motivos_Suplementos\"}},\"motivosSuplementosRenovacion\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Motivos_Suplementos\"}},\"listas\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Listas_WithName\"}},\"actividades\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Ptos_Condicionados\"}},\"industryCode\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_IndustryCode\"}},\"suscriptores\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Suscriptores\"}},\"localidades\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Localidades\"}},\"traduccionesAuxiliares\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/TranslatedString\"}},\"entidadesCia\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Aux_Entidades\"}},\"coaseguro_IdCompaniaBerkley\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"InitialDataForBeitsPageDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/InitialDataForBeitsPageDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"InstallmentDTO\":{\"type\":\"object\",\"properties\":{\"iD_Cot\":{\"type\":\"integer\",\"format\":\"int32\"},\"n_Cotizacion\":{\"type\":\"integer\",\"format\":\"int32\"},\"n_Periodo\":{\"type\":\"integer\",\"format\":\"int32\"},\"f_Efecto_Rec\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"prima\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"recargo_Fraccto\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"impuestos\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"clea\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"consorcio\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tributos\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"otros_Impuestos\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"prima_Recibo\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"basePrima\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"IssueDTO\":{\"type\":\"object\",\"properties\":{\"idCotizacion\":{\"type\":\"integer\",\"format\":\"int32\"},\"nroCotizacion\":{\"type\":\"integer\",\"format\":\"int32\"},\"documentos\":{\"type\":\"boolean\"},\"pantallaOrigen\":{\"type\":[\"string\",\"null\"]},\"hostOrigen\":{\"type\":[\"string\",\"null\"]},\"idPais\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"idSup\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"idMarco\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"selectorDocumentosVisible\":{\"type\":\"boolean\"},\"listaDocumentosSeleccionados\":{\"type\":[\"string\",\"null\"]},\"emitirRecibos\":{\"type\":\"boolean\"},\"motivoSuplemento\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"IssuePolicyPostDTO\":{\"type\":\"object\",\"properties\":{\"quoteIdentification\":{\"$ref\":\"#/components/schemas/QuoteIdentificationAffinitiesDTO\"},\"digitalSignature\":{\"type\":\"boolean\"},\"documentManagement\":{\"$ref\":\"#/components/schemas/DocumentManagementPostDTO\"}},\"additionalProperties\":false},\"IssueResponseDTO\":{\"type\":\"object\",\"properties\":{\"idCotizacion\":{\"type\":[\"string\",\"null\"]},\"nroCotizacion\":{\"type\":[\"string\",\"null\"]},\"id_Susc\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"id_Marco\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"urlRedirect\":{\"type\":[\"string\",\"null\"]},\"validaciones\":{\"$ref\":\"#/components/schemas/QuoteAlertsDTO\"}},\"additionalProperties\":false},\"IssueResponseDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/IssueResponseDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"ListConfigDTO\":{\"type\":\"object\",\"properties\":{\"listId\":{\"type\":[\"string\",\"null\"]},\"items\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/SelectListItemDTO\"}}},\"additionalProperties\":false},\"OptionalCoverage\":{\"type\":\"object\",\"properties\":{\"cobertura\":{\"type\":[\"string\",\"null\"]},\"esVisible\":{\"type\":[\"string\",\"null\"]},\"desc_Cobertura\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PaymentConfigurationDTO\":{\"type\":\"object\",\"properties\":{\"paymentType\":{\"type\":[\"string\",\"null\"]},\"paymentMethod\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PaymentManagementDTO\":{\"type\":\"object\",\"properties\":{\"gestionCobro\":{\"type\":[\"string\",\"null\"]},\"formaDePago\":{\"type\":[\"string\",\"null\"]},\"iban\":{\"type\":[\"string\",\"null\"]},\"ccc\":{\"type\":[\"string\",\"null\"]},\"nroPlazos\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"}},\"additionalProperties\":false},\"PaymentPostDTO\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":[\"string\",\"null\"]},\"paymentMethod\":{\"type\":[\"string\",\"null\"]},\"iban\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PolicyHolderDTO\":{\"type\":\"object\",\"properties\":{\"cliente\":{\"type\":[\"string\",\"null\"]},\"nif\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"telefono\":{\"type\":[\"string\",\"null\"]},\"iD_Pais\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"provincia\":{\"type\":[\"string\",\"null\"]},\"localidad\":{\"type\":[\"string\",\"null\"]},\"direccion\":{\"type\":[\"string\",\"null\"]},\"codPostal\":{\"type\":[\"string\",\"null\"]},\"segundaDireccion\":{\"$ref\":\"#/components/schemas/SecondAddressDTO\"}},\"additionalProperties\":false},\"PolicyHolderPDTO\":{\"type\":\"object\",\"properties\":{\"tomador\":{\"type\":[\"string\",\"null\"]},\"direccion\":{\"type\":[\"string\",\"null\"]},\"calle\":{\"type\":[\"string\",\"null\"]},\"localidad\":{\"type\":[\"string\",\"null\"]},\"provincia\":{\"type\":[\"string\",\"null\"]},\"cod_Postal\":{\"type\":[\"string\",\"null\"]},\"pais\":{\"type\":[\"string\",\"null\"]},\"cod_Pais\":{\"type\":\"integer\",\"format\":\"int32\"},\"cif\":{\"type\":[\"string\",\"null\"]},\"id\":{\"type\":\"integer\",\"format\":\"int32\"},\"tipo\":{\"type\":[\"string\",\"null\"]},\"nombre\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PolicyHolderPDTOListResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/PolicyHolderPDTO\"}},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"PolicyResponseDTO\":{\"type\":\"object\",\"properties\":{\"quoteId\":{\"type\":\"integer\",\"format\":\"int32\"},\"quoteNumber\":{\"type\":\"integer\",\"format\":\"int32\"},\"idPolicy\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PolicyResponseDTOResponseAffinities\":{\"type\":\"object\",\"properties\":{\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"data\":{\"$ref\":\"#/components/schemas/PolicyResponseDTO\"},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModelAffinities\"}},\"additionalProperties\":false},\"PremiumCalculationResultDTO\":{\"type\":\"object\",\"properties\":{\"tarifa\":{\"$ref\":\"#/components/schemas/PremiumCalculationResultDTO_Tariff\"},\"anioActual\":{\"$ref\":\"#/components/schemas/PremiumCalculationResultDTO_CurrentYear\"},\"suplemento\":{\"$ref\":\"#/components/schemas/PremiumCalculationResultDTO_Endorsement\"},\"primaRenovacion\":{\"$ref\":\"#/components/schemas/PremiumCalculationResultDTO_RenewalPremium\"},\"validaciones\":{\"$ref\":\"#/components/schemas/QuoteAlertsDTO\"},\"fraccionamientos\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/InstallmentDTO\"}},\"detallePricing\":{\"$ref\":\"#/components/schemas/PricingDetailDTO\"},\"mostrarPrimaTecnica\":{\"type\":\"boolean\"},\"anularRecibosAnteriores\":{\"type\":[\"string\",\"null\"]},\"listaRecibosAnulados\":{\"type\":[\"string\",\"null\"]},\"sinFraccionamiento\":{\"type\":[\"string\",\"null\"]},\"sinRecibos\":{\"type\":[\"string\",\"null\"]},\"fraccionamientoAdaptado\":{\"type\":\"boolean\"},\"tipoCalculo\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PremiumCalculationResultDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/PremiumCalculationResultDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"PremiumCalculationResultDTO_CurrentYear\":{\"type\":\"object\",\"properties\":{\"fechaEfecto\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"fechaVencimiento\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"porcentajeDescuento\":{\"type\":\"number\",\"format\":\"double\"},\"primaNeta\":{\"type\":\"number\",\"format\":\"double\"},\"recargo\":{\"type\":\"number\",\"format\":\"double\"},\"tax1\":{\"type\":\"number\",\"format\":\"double\"},\"tax2\":{\"type\":\"number\",\"format\":\"double\"},\"tax3\":{\"type\":\"number\",\"format\":\"double\"},\"tax4\":{\"type\":\"number\",\"format\":\"double\"},\"tax5\":{\"type\":\"number\",\"format\":\"double\"},\"primaTotal\":{\"type\":\"number\",\"format\":\"double\"},\"porcentajeComision\":{\"type\":\"number\",\"format\":\"double\"},\"comision\":{\"type\":\"number\",\"format\":\"double\"},\"primaNetaDeComision\":{\"type\":\"number\",\"format\":\"double\"},\"primaConRecargo\":{\"type\":\"number\",\"format\":\"double\",\"readOnly\":true}},\"additionalProperties\":false},\"PremiumCalculationResultDTO_Endorsement\":{\"type\":\"object\",\"properties\":{\"fechaEfecto\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"fechaVencimiento\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"primaNeta\":{\"type\":\"number\",\"format\":\"double\"},\"recargo\":{\"type\":\"number\",\"format\":\"double\"},\"tax1\":{\"type\":\"number\",\"format\":\"double\"},\"tax2\":{\"type\":\"number\",\"format\":\"double\"},\"tax3\":{\"type\":\"number\",\"format\":\"double\"},\"tax4\":{\"type\":\"number\",\"format\":\"double\"},\"tax5\":{\"type\":\"number\",\"format\":\"double\"},\"primaTotal\":{\"type\":\"number\",\"format\":\"double\"},\"comision\":{\"type\":\"number\",\"format\":\"double\"},\"suplementoAnualizable\":{\"type\":[\"string\",\"null\"]},\"suplementoRenovable\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PremiumCalculationResultDTO_RenewalPremium\":{\"type\":\"object\",\"properties\":{\"sistemaAnioActual\":{\"type\":\"number\",\"format\":\"double\"},\"sistemaSuplemento\":{\"type\":\"number\",\"format\":\"double\"},\"suscriptor\":{\"type\":\"number\",\"format\":\"double\"},\"rateIncreaseDefecto\":{\"type\":\"number\",\"format\":\"double\"},\"rateIncreaseSuscriptor\":{\"type\":\"number\",\"format\":\"double\"},\"primaRenovacion\":{\"type\":\"number\",\"format\":\"double\"},\"rateIncreaseDescripcion\":{\"type\":[\"string\",\"null\"]},\"rateIncreaseErrores\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PremiumCalculationResultDTO_Tariff\":{\"type\":\"object\",\"properties\":{\"primaTecnica\":{\"type\":\"number\",\"format\":\"double\"},\"descuentoAcuerdo\":{\"type\":\"number\",\"format\":\"double\"},\"primaTarifaAnual\":{\"type\":\"number\",\"format\":\"double\"},\"primaTarifaProrrateada\":{\"type\":\"number\",\"format\":\"double\"}},\"additionalProperties\":false},\"PremiumControlList\":{\"type\":\"object\",\"properties\":{\"list\":{\"type\":[\"string\",\"null\"]},\"default\":{\"type\":[\"string\",\"null\"]},\"control\":{\"type\":[\"string\",\"null\"]},\"campoFijo\":{\"type\":\"boolean\"}},\"additionalProperties\":false},\"PremiumDetailDTO\":{\"type\":\"object\",\"properties\":{\"basePrima\":{\"type\":[\"string\",\"null\"]},\"prima\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaTarifa\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaTotal\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaAnualidad\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaRenovacion\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaRenovacionSuscriptor\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaTecnica\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax1\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax2\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax3\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax4\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"otrosImpuestos\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comision\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"porcentajeComision\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"porcentajeDescuento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"recargo\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"recargoEspecial\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tasa\":{\"type\":\"number\",\"format\":\"double\"},\"tasaTarifa\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"part\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comAdmon\":{\"type\":[\"number\",\"null\"],\"format\":\"float\"},\"enExceso\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"porcentajeDescuentoAcuerdo\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"expectedLoss\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"rateIncrease\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"rateIncreaseSuscriptor\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tipoCalculo\":{\"type\":[\"string\",\"null\"]},\"error\":{\"type\":[\"string\",\"null\"]},\"acta\":{\"type\":[\"string\",\"null\"]},\"opciones\":{\"type\":[\"string\",\"null\"]},\"sobrescribirPrimaRenovacion\":{\"type\":\"boolean\",\"readOnly\":true},\"sobrescribirRateIncrease\":{\"type\":\"boolean\",\"readOnly\":true},\"suplementoRenovable\":{\"type\":[\"string\",\"null\"]},\"suplementoAnualizable\":{\"type\":[\"string\",\"null\"]},\"anularRecibosAnteriores\":{\"type\":[\"string\",\"null\"]},\"listaRecibosAnulados\":{\"type\":[\"string\",\"null\"]},\"sinFraccionamiento\":{\"type\":[\"string\",\"null\"]},\"sinRecibos\":{\"type\":[\"string\",\"null\"]},\"fraccionamientoAdaptado\":{\"type\":\"boolean\"},\"tieneFraccionamientoAdaptado\":{\"type\":\"boolean\"},\"primaRenovacionSuplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaSuplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"recargoSuplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax1Suplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax2Suplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax3Suplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax4Suplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaTotalSuplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comisionSuplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"installments\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/InstallmentDTO\"}}},\"additionalProperties\":false},\"PremiumResponseDTO\":{\"type\":\"object\",\"properties\":{\"premium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"annualPremium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"consortium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"taxes\":{\"type\":\"number\",\"format\":\"double\",\"readOnly\":true},\"totalPremium\":{\"type\":\"number\",\"format\":\"double\",\"readOnly\":true}},\"additionalProperties\":false},\"PricingDetailDTO\":{\"type\":\"object\",\"properties\":{\"iD_Cot\":{\"type\":\"integer\",\"format\":\"int32\"},\"n_Cotizacion\":{\"type\":\"integer\",\"format\":\"int32\"},\"premiumTechnical\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"premiumTarget\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"expectedLoss\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"acta\":{\"type\":[\"string\",\"null\"]},\"errors\":{\"type\":[\"string\",\"null\"]},\"warnings\":{\"type\":[\"string\",\"null\"]},\"pricingFormula\":{\"$ref\":\"#/components/schemas/ActuarialPricingFormula\"},\"premiumByCoverages\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ControlInformation\"}}},\"additionalProperties\":false},\"PricingDetailDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/PricingDetailDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"ProblemDetails\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":[\"string\",\"null\"]},\"title\":{\"type\":[\"string\",\"null\"]},\"status\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"detail\":{\"type\":[\"string\",\"null\"]},\"instance\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":{}},\"Prod_Coberturas\":{\"type\":\"object\",\"properties\":{\"iD_cot\":{\"type\":\"integer\",\"format\":\"int32\"},\"n_Cotizacion\":{\"type\":\"integer\",\"format\":\"int32\"},\"cobertura\":{\"type\":[\"string\",\"null\"]},\"limite\":{\"type\":[\"string\",\"null\"]},\"valor\":{\"type\":[\"string\",\"null\"]},\"n_Riesgo\":{\"type\":\"integer\",\"format\":\"int32\"},\"id\":{\"type\":[\"string\",\"null\"]},\"respuesta\":{\"type\":[\"string\",\"null\"]},\"codigo\":{\"type\":[\"string\",\"null\"]},\"tipo_Campo\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Prod_Preguntas\":{\"type\":\"object\",\"properties\":{\"iD_cot\":{\"type\":\"integer\",\"format\":\"int32\"},\"n_Cotizacion\":{\"type\":\"integer\",\"format\":\"int32\"},\"pregunta\":{\"type\":[\"string\",\"null\"]},\"respuesta\":{\"type\":[\"string\",\"null\"]},\"n_Riesgo\":{\"type\":\"integer\",\"format\":\"int32\"},\"n_Fila\":{\"type\":\"integer\",\"format\":\"int32\"},\"id\":{\"type\":[\"string\",\"null\"]},\"iD_Pregunta\":{\"type\":[\"string\",\"null\"]},\"objeto\":{\"type\":[\"string\",\"null\"]},\"orden\":{\"type\":\"integer\",\"format\":\"int32\"},\"incluirEnCuestionario\":{\"type\":[\"string\",\"null\"]},\"tipo_pregunta\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Product\":{\"type\":\"object\",\"properties\":{\"loB\":{\"type\":[\"string\",\"null\"]},\"loBMkt\":{\"type\":[\"string\",\"null\"]},\"producto\":{\"type\":[\"string\",\"null\"]},\"descripcion\":{\"type\":[\"string\",\"null\"]},\"version\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"delimitacionTemp\":{\"type\":[\"string\",\"null\"]},\"meses\":{\"type\":[\"string\",\"null\"]},\"delimitacionGeo\":{\"type\":[\"string\",\"null\"]},\"coaseguro\":{\"type\":[\"string\",\"null\"]},\"reaseguro\":{\"type\":[\"string\",\"null\"]},\"admonPublica\":{\"type\":[\"string\",\"null\"]},\"ensayoClinico\":{\"type\":[\"string\",\"null\"]},\"colectivo\":{\"type\":[\"string\",\"null\"]},\"polizaEnExceso\":{\"type\":[\"string\",\"null\"]},\"gestionCobro\":{\"type\":[\"string\",\"null\"]},\"formaDePago\":{\"type\":[\"string\",\"null\"]},\"aTermino\":{\"type\":[\"string\",\"null\"]},\"recargoT\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"recargoS\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"capital\":{\"type\":[\"string\",\"null\"]},\"agregado\":{\"type\":[\"string\",\"null\"]},\"impuestos\":{\"type\":[\"string\",\"null\"]},\"clea\":{\"type\":[\"string\",\"null\"]},\"consorcio\":{\"type\":[\"string\",\"null\"]},\"tributos\":{\"type\":[\"string\",\"null\"]},\"tipoPoliza\":{\"type\":[\"string\",\"null\"]},\"sqlPoliza\":{\"type\":[\"string\",\"null\"]},\"sqlPolizaStr\":{\"type\":[\"string\",\"null\"]},\"iD_Susc\":{\"type\":[\"string\",\"null\"]},\"tipoPrima\":{\"type\":[\"string\",\"null\"]},\"regularizableIPC\":{\"type\":[\"string\",\"null\"]},\"pct_Com\":{\"type\":[\"string\",\"null\"]},\"formula\":{\"type\":[\"string\",\"null\"]},\"reglas\":{\"type\":[\"string\",\"null\"]},\"coberturasOpcionales\":{\"type\":[\"string\",\"null\"]},\"anchoTablaPreg\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"configuracion\":{\"type\":[\"string\",\"null\"]},\"moneda_Orig\":{\"type\":[\"string\",\"null\"]},\"suscriptor\":{\"type\":[\"string\",\"null\"]},\"limite_Victima\":{\"type\":[\"string\",\"null\"]},\"concurso\":{\"type\":[\"string\",\"null\"]},\"legal_Entity\":{\"type\":\"integer\",\"format\":\"int32\"},\"profit_Center\":{\"type\":\"integer\",\"format\":\"int32\"},\"rate_Increase\":{\"type\":\"number\",\"format\":\"double\"},\"referal\":{\"type\":[\"string\",\"null\"]},\"questions\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Question\"}},\"coverages\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Coverage\"}}},\"additionalProperties\":false},\"ProductConfigurationDTO\":{\"type\":\"object\",\"properties\":{\"product\":{\"type\":[\"string\",\"null\"]},\"subRiskTypes\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/SubRiskTypeDTO\"}},\"paymentManagement\":{\"$ref\":\"#/components/schemas/PaymentConfigurationDTO\"},\"questions\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/QuestionDTO\"}},\"lists\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ListConfigDTO\"}}},\"additionalProperties\":false},\"ProductConfigurationDTOResponseAffinities\":{\"type\":\"object\",\"properties\":{\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"data\":{\"$ref\":\"#/components/schemas/ProductConfigurationDTO\"},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModelAffinities\"}},\"additionalProperties\":false},\"ProductsGenerateDocumentDTO\":{\"type\":\"object\",\"properties\":{\"idCotizacion\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"nroCotizacion\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"tipoDocumento\":{\"type\":[\"string\",\"null\"]},\"estadoCotizacion\":{\"type\":[\"string\",\"null\"]},\"marcaWord\":{\"type\":[\"string\",\"null\"]},\"idPais\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"pantallaOrigen\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Ptos_Condicionados\":{\"type\":\"object\",\"properties\":{\"producto\":{\"type\":[\"string\",\"null\"]},\"condicionado\":{\"type\":[\"string\",\"null\"]},\"actividad\":{\"type\":\"integer\",\"format\":\"int32\"},\"pais\":{\"type\":[\"string\",\"null\"]},\"subTipoRiesgo\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Question\":{\"type\":\"object\",\"properties\":{\"producto\":{\"type\":[\"string\",\"null\"]},\"iD_Pregunta\":{\"type\":[\"string\",\"null\"]},\"orden\":{\"type\":\"integer\",\"format\":\"int32\"},\"tipo\":{\"$ref\":\"#/components/schemas/FieldTypeEnum\"},\"pregunta\":{\"type\":[\"string\",\"null\"]},\"opcionesCombo\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/SelectListItem\"}},\"porDefecto\":{\"type\":[\"string\",\"null\"]},\"unidades\":{\"type\":[\"string\",\"null\"]},\"esObligatoria\":{\"type\":[\"string\",\"null\"]},\"validacion\":{\"type\":[\"string\",\"null\"]},\"multiRiesgo\":{\"type\":\"boolean\"},\"ayuda\":{\"type\":[\"string\",\"null\"]},\"esVisible\":{\"type\":[\"string\",\"null\"]},\"tipo_pregunta\":{\"type\":[\"string\",\"null\"]},\"valores\":{\"type\":[\"string\",\"null\"]},\"ancho\":{\"type\":[\"string\",\"null\"]},\"esAutoPostBack\":{\"type\":[\"string\",\"null\"]},\"iD2_Pregunta\":{\"type\":[\"string\",\"null\"]},\"tipoRiesgo\":{\"type\":\"integer\",\"format\":\"int32\"},\"isSection\":{\"type\":\"boolean\"},\"objeto\":{\"type\":[\"string\",\"null\"]},\"listId\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"QuestionAnswerDTO\":{\"type\":\"object\",\"properties\":{\"iD_Pregunta\":{\"type\":[\"string\",\"null\"]},\"respuesta\":{\"type\":[\"string\",\"null\"]},\"numeroFila\":{\"type\":[\"string\",\"null\"]},\"tipoCampo\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"QuestionDTO\":{\"type\":\"object\",\"properties\":{\"questionId\":{\"type\":[\"string\",\"null\"]},\"questionText\":{\"type\":[\"string\",\"null\"]},\"listId\":{\"type\":[\"string\",\"null\"]},\"isRequired\":{\"type\":\"boolean\"},\"riskType\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"helpText\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"QuestionPostDTO\":{\"type\":\"object\",\"properties\":{\"questionId\":{\"type\":[\"string\",\"null\"]},\"answer\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"QuoteAlertsDTO\":{\"type\":\"object\",\"properties\":{\"alertas\":{\"type\":[\"string\",\"null\"]},\"errores\":{\"type\":[\"string\",\"null\"]},\"avisosPreEmision\":{\"type\":[\"string\",\"null\"]},\"especiales\":{\"type\":[\"string\",\"null\"]},\"forzarVisibilidadModal\":{\"type\":\"boolean\"}},\"additionalProperties\":false},\"QuoteDatesDTO\":{\"type\":\"object\",\"properties\":{\"solicitud\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"cotizacion\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"inicioPoliza\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"vencimientoPoliza\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"inicioSuplemento\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"vencimientoSuplemento\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"retro\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"revision\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"emision\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"horaInicio\":{\"type\":\"integer\",\"format\":\"int32\"},\"horaVencimiento\":{\"type\":\"integer\",\"format\":\"int32\"},\"efectoInicial\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"}},\"additionalProperties\":false},\"QuoteDetailDTO\":{\"type\":\"object\",\"properties\":{\"producto\":{\"type\":[\"string\",\"null\"]},\"loB\":{\"type\":[\"string\",\"null\"]},\"estado\":{\"type\":\"integer\",\"format\":\"int32\"},\"subtipoRiesgoCodigoActividad\":{\"type\":\"integer\",\"format\":\"int32\"},\"subtipoRiesgoDescripcion\":{\"type\":[\"string\",\"null\"]},\"observacionesSuscriptor\":{\"type\":[\"string\",\"null\"]},\"delimitacionTemporal\":{\"type\":[\"string\",\"null\"]},\"meses\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"delimitacionGeografica\":{\"type\":[\"string\",\"null\"]},\"coaseguro\":{\"type\":[\"string\",\"null\"]},\"reaseguro\":{\"type\":[\"string\",\"null\"]},\"admonPublica\":{\"type\":[\"string\",\"null\"]},\"ensayoClinico\":{\"type\":[\"string\",\"null\"]},\"colectivo\":{\"type\":[\"string\",\"null\"]},\"polizaEnExceso\":{\"type\":[\"string\",\"null\"]},\"aTermino\":{\"type\":[\"string\",\"null\"]},\"suscriptor\":{\"type\":[\"string\",\"null\"]},\"canal\":{\"type\":[\"string\",\"null\"]},\"legalEntity\":{\"type\":\"integer\",\"format\":\"int32\"},\"profitCenter\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"usuarioComercial\":{\"type\":[\"string\",\"null\"]},\"corredorDescripcion\":{\"type\":[\"string\",\"null\"]},\"corredorCodigo\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"oficina\":{\"type\":[\"string\",\"null\"]},\"aseguradoraActual\":{\"type\":[\"string\",\"null\"]},\"historial\":{\"type\":[\"string\",\"null\"]},\"zona\":{\"type\":[\"string\",\"null\"]},\"nroAsegurados\":{\"type\":\"integer\",\"format\":\"int32\"},\"facturacion\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"franquicia\":{\"type\":[\"string\",\"null\"]},\"nroPlazos\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"renovacionTacita\":{\"type\":[\"string\",\"null\"]},\"regularizableIPC\":{\"type\":[\"string\",\"null\"]},\"nroSuplemento\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"anularRecibosAnteriores\":{\"type\":[\"string\",\"null\"]},\"listaRecibosAnulados\":{\"type\":[\"string\",\"null\"]},\"fraccionamientoAdaptado\":{\"type\":\"boolean\"},\"sinFraccionamiento\":{\"type\":\"boolean\"},\"sinRecibos\":{\"type\":\"boolean\"},\"corredorOficinaCodigo\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"concurso\":{\"type\":[\"string\",\"null\"]},\"enExceso\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"observacionesBroker\":{\"type\":[\"string\",\"null\"]},\"cantidadRiesgos\":{\"type\":\"integer\",\"format\":\"int32\"},\"noRenovar\":{\"type\":\"boolean\"},\"motivoRevision\":{\"type\":[\"string\",\"null\"]},\"motivoSuplemento\":{\"type\":[\"string\",\"null\"]},\"descripcionSuplemento\":{\"type\":[\"string\",\"null\"]},\"coberturasOpcionales\":{\"type\":[\"string\",\"null\"]},\"etiquetas\":{\"type\":[\"string\",\"null\"]},\"tipoCot\":{\"type\":[\"string\",\"null\"]},\"tipoPoliza\":{\"type\":[\"string\",\"null\"]},\"industryCodeID\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"riesgoNombreFlota\":{\"type\":[\"string\",\"null\"]},\"acuerdoCampania\":{\"type\":[\"string\",\"null\"]},\"fechaRoE\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"roE\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"monedaOriginal\":{\"type\":[\"string\",\"null\"]},\"corredorSecundarioCodigo\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"corredorSecundarioComision\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tasa\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"poliza\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"polizaStr\":{\"type\":[\"string\",\"null\"]},\"cia\":{\"type\":[\"string\",\"null\"]},\"ciA_Corta\":{\"type\":[\"string\",\"null\"]},\"campana\":{\"type\":[\"string\",\"null\"]},\"paquete\":{\"type\":[\"string\",\"null\"]},\"default_Currency\":{\"type\":[\"string\",\"null\"]},\"productoDescripcion\":{\"type\":[\"string\",\"null\"]},\"gestionCobro\":{\"type\":[\"string\",\"null\"]},\"formaDePago\":{\"type\":[\"string\",\"null\"]},\"fechaSolicitud\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"}},\"additionalProperties\":false},\"QuoteIdentificationAffinitiesDTO\":{\"required\":[\"quoteId\",\"quoteNumber\"],\"type\":\"object\",\"properties\":{\"quoteId\":{\"maximum\":2147483647,\"minimum\":1,\"type\":\"integer\",\"format\":\"int32\",\"default\":1},\"quoteNumber\":{\"maximum\":2147483647,\"minimum\":0,\"type\":\"integer\",\"format\":\"int32\",\"default\":0}},\"additionalProperties\":false},\"QuoteInitialDataDTO\":{\"type\":\"object\",\"properties\":{\"iD_Cot\":{\"type\":\"integer\",\"format\":\"int32\"},\"n_Cotizacion\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"iD_Sup\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"iD_Susc\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"iD_Marco\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"tipoCotizacion\":{\"$ref\":\"#/components/schemas/QuoteType\"},\"nuevaCotizacion\":{\"type\":\"boolean\",\"readOnly\":true},\"fechas\":{\"$ref\":\"#/components/schemas/QuoteDatesDTO\"},\"detalle\":{\"$ref\":\"#/components/schemas/QuoteDetailDTO\"},\"detallePago\":{\"$ref\":\"#/components/schemas/PaymentManagementDTO\"},\"tomador\":{\"$ref\":\"#/components/schemas/PolicyHolderDTO\"},\"exposicion\":{\"$ref\":\"#/components/schemas/ExpositionDTO\"},\"detalleCoaseguro\":{\"$ref\":\"#/components/schemas/CoinsuranceDetailDTO\"},\"chequeo\":{\"$ref\":\"#/components/schemas/ValidationChecksDTO\"},\"detallePrima\":{\"$ref\":\"#/components/schemas/PremiumDetailDTO\"},\"riesgos\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/RiskDTO\"}},\"auditoria\":{\"$ref\":\"#/components/schemas/AuditDTO\"},\"auxiliarData\":{\"$ref\":\"#/components/schemas/AuxiliarData\"},\"configuracionBranch\":{\"$ref\":\"#/components/schemas/UserQuoteAdmIniConfiguration\"},\"documentacion\":{\"$ref\":\"#/components/schemas/DocumentatinDTO\"},\"detallePricing\":{\"$ref\":\"#/components/schemas/PricingDetailDTO\"},\"questionsAnswers\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Prod_Preguntas\"}},\"coveragesAnswers\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/Prod_Coberturas\"}}},\"additionalProperties\":false},\"QuotePostDTO\":{\"type\":\"object\",\"properties\":{\"product\":{\"type\":[\"string\",\"null\"]},\"subRiskType\":{\"type\":\"integer\",\"format\":\"int32\"},\"startDate\":{\"type\":\"string\",\"format\":\"date-time\"},\"endDate\":{\"type\":\"string\",\"format\":\"date-time\"},\"client\":{\"$ref\":\"#/components/schemas/ClientPostDTO\"},\"paymentManagement\":{\"$ref\":\"#/components/schemas/PaymentPostDTO\"},\"risks\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/RiskPostDTO\"}},\"documentManagement\":{\"$ref\":\"#/components/schemas/DocumentManagementPostDTO\"}},\"additionalProperties\":false},\"QuoteType\":{\"enum\":[0,1,2,3,4,5,6,7],\"type\":\"integer\",\"format\":\"int32\"},\"QuoteUpdateAuxiliarDTO\":{\"type\":\"object\",\"properties\":{\"n_CotizacionOrigen\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"estadoCodigo\":{\"type\":[\"string\",\"null\"]},\"modoPagina\":{\"type\":[\"string\",\"null\"]},\"suplementoRenovableVisible\":{\"type\":\"boolean\"},\"cambioPorComplexPricing\":{\"type\":\"boolean\"},\"pantallaOrigen\":{\"type\":[\"string\",\"null\"]},\"hostOrigen\":{\"type\":[\"string\",\"null\"]},\"cambioPorTipoCalculoReciboAdaptado\":{\"type\":\"boolean\"},\"autorizacionesNT\":{\"type\":[\"string\",\"null\"]},\"usuarioAutoriza\":{\"type\":[\"string\",\"null\"]},\"usuarioAutorizaTexto\":{\"type\":[\"string\",\"null\"]},\"motivoSuplementoTexto\":{\"type\":[\"string\",\"null\"]},\"productoDescripcion\":{\"type\":[\"string\",\"null\"]},\"actividadTexto\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"QuoteUpdateDTO\":{\"type\":\"object\",\"properties\":{\"idCotizacion\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"nroCotizacion\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"iD_Sup\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"iD_Susc\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"iD_Marco\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"fechas\":{\"$ref\":\"#/components/schemas/QuoteUpdateDatesDTO\"},\"detalle\":{\"$ref\":\"#/components/schemas/QuoteUpdateDetailDTO\"},\"detallePago\":{\"$ref\":\"#/components/schemas/PaymentManagementDTO\"},\"tomador\":{\"$ref\":\"#/components/schemas/PolicyHolderDTO\"},\"exposicion\":{\"$ref\":\"#/components/schemas/QuoteUpdateExpositionDTO\"},\"detalleCoaseguro\":{\"$ref\":\"#/components/schemas/CoinsuranceDetailDTO\"},\"chequeo\":{\"$ref\":\"#/components/schemas/ValidationChecksDTO\"},\"auxiliarData\":{\"$ref\":\"#/components/schemas/QuoteUpdateAuxiliarDTO\"},\"detalleCalculoPrima\":{\"$ref\":\"#/components/schemas/QuoteUpdatePremiumDTO\"},\"riesgos\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/RiskDTO\"}},\"detallePricing\":{\"$ref\":\"#/components/schemas/PricingDetailDTO\"}},\"additionalProperties\":false},\"QuoteUpdateDatesDTO\":{\"type\":\"object\",\"properties\":{\"inicioPoliza\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"vencimientoPoliza\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"inicioSuplemento\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"vencimientoSuplemento\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"retro\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"horaInicio\":{\"type\":\"integer\",\"format\":\"int32\"},\"horaVencimiento\":{\"type\":\"integer\",\"format\":\"int32\"},\"efectoInicial\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"}},\"additionalProperties\":false},\"QuoteUpdateDetailDTO\":{\"type\":\"object\",\"properties\":{\"producto\":{\"type\":[\"string\",\"null\"]},\"loB\":{\"type\":[\"string\",\"null\"]},\"subtipoRiesgoCodigoActividad\":{\"type\":\"integer\",\"format\":\"int32\"},\"observacionesSuscriptor\":{\"type\":[\"string\",\"null\"]},\"delimitacionTemporal\":{\"type\":[\"string\",\"null\"]},\"meses\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"delimitacionGeografica\":{\"type\":[\"string\",\"null\"]},\"coaseguro\":{\"type\":[\"string\",\"null\"]},\"reaseguro\":{\"type\":[\"string\",\"null\"]},\"admonPublica\":{\"type\":[\"string\",\"null\"]},\"ensayoClinico\":{\"type\":[\"string\",\"null\"]},\"colectivo\":{\"type\":[\"string\",\"null\"]},\"polizaEnExceso\":{\"type\":[\"string\",\"null\"]},\"aTermino\":{\"type\":[\"string\",\"null\"]},\"suscriptor\":{\"type\":[\"string\",\"null\"]},\"canal\":{\"type\":[\"string\",\"null\"]},\"legalEntity\":{\"type\":\"integer\",\"format\":\"int32\"},\"profitCenter\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"corredorDescripcion\":{\"type\":[\"string\",\"null\"]},\"corredorCodigo\":{\"type\":\"integer\",\"format\":\"int32\"},\"oficina\":{\"type\":[\"string\",\"null\"]},\"zona\":{\"type\":[\"string\",\"null\"]},\"nroAsegurados\":{\"type\":\"integer\",\"format\":\"int32\"},\"renovacionTacita\":{\"type\":[\"string\",\"null\"]},\"regularizableIPC\":{\"type\":[\"string\",\"null\"]},\"nroSuplemento\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"corredorOficinaCodigo\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"concurso\":{\"type\":[\"string\",\"null\"]},\"enExceso\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"observacionesBroker\":{\"type\":[\"string\",\"null\"]},\"cantidadRiesgos\":{\"type\":\"integer\",\"format\":\"int32\"},\"noRenovar\":{\"type\":\"boolean\"},\"motivoRevision\":{\"type\":[\"string\",\"null\"]},\"motivoSuplemento\":{\"type\":[\"string\",\"null\"]},\"descripcionSuplemento\":{\"type\":[\"string\",\"null\"]},\"coberturasOpcionales\":{\"type\":[\"string\",\"null\"]},\"etiquetas\":{\"type\":[\"string\",\"null\"]},\"tipoCotizacion\":{\"type\":[\"string\",\"null\"]},\"tipoPoliza\":{\"type\":[\"string\",\"null\"]},\"estadoCodigo\":{\"type\":[\"string\",\"null\"]},\"industryCodeID\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"riesgoNombreFlota\":{\"type\":[\"string\",\"null\"]},\"acuerdoCampania\":{\"type\":[\"string\",\"null\"]},\"fechaRoE\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"roE\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"monedaOriginal\":{\"type\":[\"string\",\"null\"]},\"corredorSecundarioCodigo\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"corredorSecundarioComision\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"usuarioComercial\":{\"type\":[\"string\",\"null\"]},\"tasa\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"poliza\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"}},\"additionalProperties\":false},\"QuoteUpdateExpositionDTO\":{\"type\":\"object\",\"properties\":{\"capital\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"agregado\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"limiteVictima\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"}},\"additionalProperties\":false},\"QuoteUpdatePremiumDTO\":{\"type\":\"object\",\"properties\":{\"basePrima\":{\"type\":[\"string\",\"null\"]},\"sobrescribirPrimaRenovacion\":{\"type\":\"boolean\"},\"prima\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaRenovacionSuscriptor\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"porcentajeComision\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"porcentajeDescuento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"recargoEspecial\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"sobrescribirRateIncrease\":{\"type\":\"boolean\"},\"rateIncreaseSuscriptor\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"suplementoRenovable\":{\"type\":[\"string\",\"null\"]},\"anularRecibosAnteriores\":{\"type\":[\"string\",\"null\"]},\"listaRecibosAnulados\":{\"type\":[\"string\",\"null\"]},\"sinFraccionamiento\":{\"type\":[\"string\",\"null\"]},\"sinRecibos\":{\"type\":[\"string\",\"null\"]},\"fraccionamientoAdaptado\":{\"type\":\"boolean\"},\"comisionSuplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaTarifa\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"primaSuplemento\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"fraccionamientos\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/InstallmentDTO\"}}},\"additionalProperties\":false},\"ReceiptForAdministrationDTO\":{\"type\":\"object\",\"properties\":{\"iD_Recibo\":{\"type\":\"integer\",\"format\":\"int32\"},\"recibo\":{\"type\":[\"string\",\"null\"]},\"f_Efecto_Rec\":{\"type\":[\"string\",\"null\"]},\"f_Vto_Rec\":{\"type\":[\"string\",\"null\"]},\"periodo_Conta\":{\"type\":\"integer\",\"format\":\"int32\"},\"corredor\":{\"type\":[\"string\",\"null\"]},\"tipo_Cobro\":{\"type\":[\"string\",\"null\"]},\"estado\":{\"type\":[\"string\",\"null\"]},\"prima_neta\":{\"type\":[\"string\",\"null\"]},\"recargo_Fraccto\":{\"type\":[\"string\",\"null\"]},\"impuestos\":{\"type\":[\"string\",\"null\"]},\"clea\":{\"type\":[\"string\",\"null\"]},\"consorcio\":{\"type\":[\"string\",\"null\"]},\"tributos\":{\"type\":[\"string\",\"null\"]},\"otros_Impuestos\":{\"type\":[\"string\",\"null\"]},\"comision\":{\"type\":[\"string\",\"null\"]},\"prima_Total\":{\"type\":[\"string\",\"null\"]},\"anulado\":{\"type\":\"boolean\"},\"anulable\":{\"type\":\"boolean\"}},\"additionalProperties\":false},\"ReceiptForAdministrationDTOIEnumerableResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ReceiptForAdministrationDTO\"}},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"ResponseAuthenticationDTO\":{\"type\":\"object\",\"properties\":{\"token\":{\"type\":[\"string\",\"null\"]},\"expiration\":{\"type\":\"string\",\"format\":\"date-time\"}},\"additionalProperties\":false},\"ResponseAuthenticationDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/ResponseAuthenticationDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"ResponseCreateRequestUnderwritingDTO\":{\"type\":\"object\",\"properties\":{\"quoteID\":{\"type\":\"integer\",\"format\":\"int32\"},\"quoteNumber\":{\"type\":\"integer\",\"format\":\"int32\"}},\"additionalProperties\":false},\"ResponseCreateRequestUnderwritingDTOResponseUnderwriting\":{\"type\":\"object\",\"properties\":{\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"data\":{\"$ref\":\"#/components/schemas/ResponseCreateRequestUnderwritingDTO\"},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModelUnderwriting\"}},\"additionalProperties\":false},\"ResponsePremiumUnderwritingDTO\":{\"type\":\"object\",\"properties\":{\"premium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tariffPremium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"totalPremium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"anualPremium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"renewalPremium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax1\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax2\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax3\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax4\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"otherTaxes\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"commission\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"commissionRate\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"discountRate\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"surchargePercentage\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"surchage\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"specialSurcharge\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"rateIncrease\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"error\":{\"type\":[\"string\",\"null\"]},\"tariffErrors\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"ResponseSaveQuoteUnderwritingDTO\":{\"type\":\"object\",\"properties\":{\"quoteID\":{\"type\":[\"string\",\"null\"]},\"quoteNumber\":{\"type\":[\"string\",\"null\"]},\"premiumDetail\":{\"$ref\":\"#/components/schemas/ResponsePremiumUnderwritingDTO\"}},\"additionalProperties\":false},\"ResponseSaveQuoteUnderwritingDTOResponseUnderwriting\":{\"type\":\"object\",\"properties\":{\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"data\":{\"$ref\":\"#/components/schemas/ResponseSaveQuoteUnderwritingDTO\"},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModelUnderwriting\"}},\"additionalProperties\":false},\"RestoreOptionsDTO\":{\"type\":\"object\",\"properties\":{\"backupName\":{\"type\":[\"string\",\"null\"]},\"executeRestore\":{\"type\":\"boolean\"},\"executeSchema\":{\"type\":\"boolean\"},\"executeData\":{\"type\":\"boolean\"},\"executePostDeploy\":{\"type\":\"boolean\"},\"executeFolderScripts\":{\"type\":\"boolean\"}},\"additionalProperties\":false},\"RiskDTO\":{\"type\":\"object\",\"properties\":{\"nroRiesgo\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"preguntas\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/QuestionAnswerDTO\"}},\"coberturas\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/CoverageAnswerDTO\"}}},\"additionalProperties\":false},\"RiskPostDTO\":{\"type\":\"object\",\"properties\":{\"riskNumber\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"questions\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/QuestionPostDTO\"}}},\"additionalProperties\":false},\"SaveQuoteCoverageAnswerDTO\":{\"type\":\"object\",\"properties\":{\"coverageCode\":{\"type\":[\"string\",\"null\"]},\"limitCode\":{\"type\":[\"string\",\"null\"]},\"value\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"SaveQuoteDTO\":{\"type\":\"object\",\"properties\":{\"quoteID\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"quoteNumber\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"dates\":{\"$ref\":\"#/components/schemas/SaveQuoteDatesDTO\"},\"detail\":{\"$ref\":\"#/components/schemas/SaveQuoteDetailDTO\"},\"paymentDetail\":{\"$ref\":\"#/components/schemas/SaveQuotePaymentDTO\"},\"policyHolder\":{\"$ref\":\"#/components/schemas/SaveQuotePolicyholderDTO\"},\"exposition\":{\"$ref\":\"#/components/schemas/SaveQuoteExpositionDTO\"},\"premiumDetail\":{\"$ref\":\"#/components/schemas/SaveQuotePremiumDTO\"},\"risks\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/SaveQuoteRiskDTO\"}}},\"additionalProperties\":false},\"SaveQuoteDTOResponseUnderwriting\":{\"type\":\"object\",\"properties\":{\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"data\":{\"$ref\":\"#/components/schemas/SaveQuoteDTO\"},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModelUnderwriting\"}},\"additionalProperties\":false},\"SaveQuoteDatesDTO\":{\"type\":\"object\",\"properties\":{\"request\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"quote\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"policyStart\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"policyEnd\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"},\"retro\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"}},\"additionalProperties\":false},\"SaveQuoteDetailDTO\":{\"type\":\"object\",\"properties\":{\"productCode\":{\"type\":[\"string\",\"null\"]},\"loB\":{\"type\":[\"string\",\"null\"]},\"stateCode\":{\"type\":\"integer\",\"format\":\"int32\"},\"riskSubtypeActivityCode\":{\"type\":\"integer\",\"format\":\"int32\"},\"temporalLimits\":{\"type\":[\"string\",\"null\"]},\"months\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"geographicalLimits\":{\"type\":[\"string\",\"null\"]},\"coinsurance\":{\"type\":[\"string\",\"null\"]},\"reinsurance\":{\"type\":[\"string\",\"null\"]},\"isPublicTender\":{\"type\":[\"string\",\"null\"]},\"publicTender\":{\"type\":[\"string\",\"null\"]},\"medicalTrial\":{\"type\":[\"string\",\"null\"]},\"groupPolicy\":{\"type\":[\"string\",\"null\"]},\"excessPolicy\":{\"type\":[\"string\",\"null\"]},\"toTerm\":{\"type\":[\"string\",\"null\"]},\"underwriter\":{\"type\":[\"string\",\"null\"]},\"canal\":{\"type\":[\"string\",\"null\"]},\"legalEntity\":{\"type\":\"integer\",\"format\":\"int32\"},\"profitCenter\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"brokerCode\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"office\":{\"type\":[\"string\",\"null\"]},\"numberInsured\":{\"type\":\"integer\",\"format\":\"int32\"},\"numberInstallments\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"tacitalRenewal\":{\"type\":[\"string\",\"null\"]},\"regularisedAccordingCPI\":{\"type\":[\"string\",\"null\"]},\"endorsementNumber\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"officeBrokerCode\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"inExcessOf\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"numberOfRisks\":{\"type\":\"integer\",\"format\":\"int32\"},\"reviewAtRenewal\":{\"type\":\"boolean\"},\"reasonForReview\":{\"type\":[\"string\",\"null\"]},\"optionalCoverages\":{\"type\":[\"string\",\"null\"]},\"industryCodeID\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"originalCurrency\":{\"type\":[\"string\",\"null\"]},\"requestDate\":{\"type\":[\"string\",\"null\"],\"format\":\"date-time\"}},\"additionalProperties\":false},\"SaveQuoteExpositionDTO\":{\"type\":\"object\",\"properties\":{\"perClaimLimit\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"aggregateLimit\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"limitPerVictim\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"}},\"additionalProperties\":false},\"SaveQuotePaymentDTO\":{\"type\":\"object\",\"properties\":{\"collectionType\":{\"type\":[\"string\",\"null\"]},\"paymentFrecuency\":{\"type\":[\"string\",\"null\"]},\"iban\":{\"type\":[\"string\",\"null\"]},\"ccc\":{\"type\":[\"string\",\"null\"]},\"numberInstallments\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"}},\"additionalProperties\":false},\"SaveQuotePolicyholderDTO\":{\"type\":\"object\",\"properties\":{\"policyholder\":{\"type\":[\"string\",\"null\"]},\"nif\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"phone\":{\"type\":[\"string\",\"null\"]},\"countryID\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"province\":{\"type\":[\"string\",\"null\"]},\"town\":{\"type\":[\"string\",\"null\"]},\"street\":{\"type\":[\"string\",\"null\"]},\"postalCode\":{\"type\":[\"string\",\"null\"]},\"secondAddress\":{\"$ref\":\"#/components/schemas/SaveQuoteSecondAddressDTO\"}},\"additionalProperties\":false},\"SaveQuotePremiumDTO\":{\"type\":\"object\",\"properties\":{\"premium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"annualTariffPremium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"totalPremium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"proratedTariffPremium\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax1\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax2\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax3\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"tax4\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"otherTaxes\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comission\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"commissionPercentage\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"}},\"additionalProperties\":false},\"SaveQuoteQuestionAnswerDTO\":{\"type\":\"object\",\"properties\":{\"questionID\":{\"type\":[\"string\",\"null\"]},\"answer\":{\"type\":[\"string\",\"null\"]},\"rowNumber\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"SaveQuoteResponseDTO\":{\"type\":\"object\",\"properties\":{\"idCotizacion\":{\"type\":[\"string\",\"null\"]},\"nroCotizacion\":{\"type\":[\"string\",\"null\"]},\"validaciones\":{\"$ref\":\"#/components/schemas/QuoteAlertsDTO\"},\"urlRedirect\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"SaveQuoteResponseDTOResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"$ref\":\"#/components/schemas/SaveQuoteResponseDTO\"},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"SaveQuoteRiskDTO\":{\"type\":\"object\",\"properties\":{\"riskNumber\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"questions\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/SaveQuoteQuestionAnswerDTO\"}},\"coverages\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/SaveQuoteCoverageAnswerDTO\"}}},\"additionalProperties\":false},\"SaveQuoteSecondAddressDTO\":{\"type\":\"object\",\"properties\":{\"hasFiscalAddress\":{\"type\":\"boolean\"},\"addAddress\":{\"type\":\"boolean\"},\"addressType\":{\"type\":[\"string\",\"null\"]},\"street\":{\"type\":[\"string\",\"null\"]},\"town\":{\"type\":[\"string\",\"null\"]},\"postalCode\":{\"type\":[\"string\",\"null\"]},\"province\":{\"type\":[\"string\",\"null\"]},\"countryID\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"nameAddress\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"Save_Mail_ServicesDTO\":{\"type\":\"object\",\"properties\":{\"action\":{\"type\":[\"string\",\"null\"]},\"tipo\":{\"type\":[\"string\",\"null\"]},\"patron\":{\"type\":[\"string\",\"null\"]},\"suscriptor\":{\"type\":[\"string\",\"null\"]},\"tramitador\":{\"type\":[\"string\",\"null\"]},\"lob\":{\"type\":[\"string\",\"null\"]},\"cliente\":{\"type\":[\"string\",\"null\"]},\"id_cot\":{\"type\":[\"string\",\"null\"]},\"poliza\":{\"type\":[\"string\",\"null\"]},\"id_sin\":{\"type\":[\"string\",\"null\"]},\"mensaje\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"SecondAddressDTO\":{\"type\":\"object\",\"properties\":{\"tieneDireccionFiscal\":{\"type\":\"boolean\"},\"agregarDireccion\":{\"type\":\"boolean\"},\"idTipoDireccion\":{\"type\":[\"string\",\"null\"]},\"calle\":{\"type\":[\"string\",\"null\"]},\"localidad\":{\"type\":[\"string\",\"null\"]},\"codPostal\":{\"type\":[\"string\",\"null\"]},\"provincia\":{\"type\":[\"string\",\"null\"]},\"idPais\":{\"type\":[\"integer\",\"null\"],\"format\":\"int32\"},\"nombre\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"SelectListItem\":{\"type\":\"object\",\"properties\":{\"text\":{\"type\":[\"string\",\"null\"]},\"value\":{\"type\":[\"string\",\"null\"]},\"orden\":{\"type\":\"integer\",\"format\":\"int32\"}},\"additionalProperties\":false},\"SelectListItemDTO\":{\"type\":\"object\",\"properties\":{\"text\":{\"type\":[\"string\",\"null\"]},\"value\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"StringIEnumerableResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":[\"array\",\"null\"],\"items\":{\"type\":\"string\"}},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"StringResponse\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":[\"string\",\"null\"]},\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModel\"}},\"additionalProperties\":false},\"SubRiskTypeDTO\":{\"type\":\"object\",\"properties\":{\"subRiskType\":{\"type\":\"integer\",\"format\":\"int32\"},\"description\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"TranslatedString\":{\"type\":\"object\",\"properties\":{\"originalValue\":{\"type\":[\"string\",\"null\"]},\"translation\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"UpdateDigitalSignResponseDTO\":{\"type\":\"object\",\"properties\":{\"signatureStatus\":{\"type\":\"integer\",\"format\":\"int32\"},\"signatureStatusDescription\":{\"type\":[\"string\",\"null\"],\"readOnly\":true},\"brokerStatus\":{\"type\":\"integer\",\"format\":\"int32\"},\"brokerStatusDescription\":{\"type\":[\"string\",\"null\"],\"readOnly\":true}},\"additionalProperties\":false},\"UpdateDigitalSignResponseDTOResponseAffinities\":{\"type\":\"object\",\"properties\":{\"isSuccess\":{\"type\":\"boolean\"},\"message\":{\"type\":[\"string\",\"null\"]},\"data\":{\"$ref\":\"#/components/schemas/UpdateDigitalSignResponseDTO\"},\"errorModel\":{\"$ref\":\"#/components/schemas/ErrorModelAffinities\"}},\"additionalProperties\":false},\"UserQuoteAdmIniConfiguration\":{\"type\":\"object\",\"properties\":{\"branch\":{\"type\":[\"string\",\"null\"]},\"segundaDireccion\":{\"type\":\"boolean\"},\"industryCode\":{\"type\":\"boolean\"},\"comisionCero\":{\"type\":\"boolean\"},\"alertaSuplementos\":{\"type\":\"boolean\"},\"controlImpuestosSuplemento\":{\"type\":\"boolean\"},\"controlImpuestosSuplementoDiferencia\":{\"type\":[\"number\",\"null\"],\"format\":\"double\"},\"comprobarIban\":{\"type\":\"boolean\"},\"disableEnterCif\":{\"type\":\"boolean\"},\"hideProvince\":{\"type\":\"boolean\"},\"showMultipleDocs\":{\"type\":\"boolean\"},\"pricing_PremiumTechnical\":{\"type\":\"boolean\"},\"pricing_ExpectedLoss\":{\"type\":\"boolean\"},\"pricing_PremiumTarget\":{\"type\":\"boolean\"},\"showProposals\":{\"type\":\"boolean\"},\"docDefault_COT\":{\"type\":[\"string\",\"null\"]},\"docDefault_COT_V\":{\"type\":[\"string\",\"null\"]},\"docDefault_POL\":{\"type\":[\"string\",\"null\"]},\"docDefault_POL_V\":{\"type\":[\"string\",\"null\"]},\"docDefault_REN\":{\"type\":[\"string\",\"null\"]},\"docDefault_REN_V\":{\"type\":[\"string\",\"null\"]},\"docDefault_SUP\":{\"type\":[\"string\",\"null\"]},\"docDefault_SUP_V\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"ValidationChecksDTO\":{\"type\":\"object\",\"properties\":{\"revisionFechas\":{\"type\":\"boolean\"},\"revisionComision\":{\"type\":\"boolean\"},\"revisionPrimas\":{\"type\":\"boolean\"},\"revisionTasa\":{\"type\":\"boolean\"}},\"additionalProperties\":false},\"WarningMessage\":{\"type\":\"object\",\"properties\":{\"titleAviso\":{\"type\":[\"string\",\"null\"]},\"title\":{\"$ref\":\"#/components/schemas/TranslatedString\"},\"titleTranslated\":{\"type\":[\"string\",\"null\"]},\"messages\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/ErrorMessage\"}}},\"additionalProperties\":false}},\"securitySchemes\":{\"Bearer\":{\"type\":\"apiKey\",\"name\":\"Authorization\",\"in\":\"header\"}}},\"security\":[{\"Bearer\":[]}],\"x-ext-urls\":{}}",
  parsed:{ openapi:"3.1.1",
    info:{ title:"API- Berkley Europe",
      version:"2.0.0" },
    paths:{ "/api/affinities/CreateQuote":{ post:{ tags:[ "Quotes" ],
          summary:"Creates a quote from an input object. Returns the quote ID and premium values",
          parameters:[ { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          requestBody:{ description:"",
            content:{ "application/json-patch+json":{ schema:{ $ref:"#/components/schemas/QuotePostDTO" } },
              "application/json":{ schema:{ $ref:"#/components/schemas/QuotePostDTO" } },
              "text/json":{ schema:{ $ref:"#/components/schemas/QuotePostDTO" } },
              "application/*+json":{ schema:{ $ref:"#/components/schemas/QuotePostDTO" } } } },
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/CreateQuoteAffinitiesResponseDTOResponseAffinities" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/CreateQuoteAffinitiesResponseDTOResponseAffinities" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/CreateQuoteAffinitiesResponseDTOResponseAffinities" } } } } } } },
      "/api/affinities/IssuePolicy":{ post:{ tags:[ "Policies" ],
          summary:"Issues a policy based on the quote ID. Asynchronously sends the policy to be digitally signed",
          parameters:[ { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          requestBody:{ description:"",
            content:{ "application/json-patch+json":{ schema:{ $ref:"#/components/schemas/IssuePolicyPostDTO" } },
              "application/json":{ schema:{ $ref:"#/components/schemas/IssuePolicyPostDTO" } },
              "text/json":{ schema:{ $ref:"#/components/schemas/IssuePolicyPostDTO" } },
              "application/*+json":{ schema:{ $ref:"#/components/schemas/IssuePolicyPostDTO" } } } },
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/PolicyResponseDTOResponseAffinities" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/PolicyResponseDTOResponseAffinities" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/PolicyResponseDTOResponseAffinities" } } } } } } },
      "/api/affinities/UpdateDigitalSignatureStatus":{ put:{ tags:[ "Documentation" ],
          summary:"Checks and updates the status of a digital signature. Upon completion, sends the signed policy to the broker.",
          parameters:[ { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          requestBody:{ description:"",
            content:{ "application/json-patch+json":{ schema:{ $ref:"#/components/schemas/QuoteIdentificationAffinitiesDTO" } },
              "application/json":{ schema:{ $ref:"#/components/schemas/QuoteIdentificationAffinitiesDTO" } },
              "text/json":{ schema:{ $ref:"#/components/schemas/QuoteIdentificationAffinitiesDTO" } },
              "application/*+json":{ schema:{ $ref:"#/components/schemas/QuoteIdentificationAffinitiesDTO" } } } },
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/UpdateDigitalSignResponseDTOResponseAffinities" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/UpdateDigitalSignResponseDTOResponseAffinities" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/UpdateDigitalSignResponseDTOResponseAffinities" } } } } } } },
      "/api/affinities/GenerateDocument":{ post:{ tags:[ "Documentation" ],
          summary:"Generates a document for a given quote and document type.",
          parameters:[ { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          requestBody:{ description:"",
            content:{ "application/json-patch+json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentRequestDTO" } },
              "application/json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentRequestDTO" } },
              "text/json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentRequestDTO" } },
              "application/*+json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentRequestDTO" } } } },
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities" } } } } } } },
      "/api/affinities/DownloadDocument":{ post:{ tags:[ "Documentation" ],
          summary:"Downloads a document for a given quote and document type.",
          parameters:[ { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          requestBody:{ description:"",
            content:{ "application/json-patch+json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentRequestDTO" } },
              "application/json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentRequestDTO" } },
              "text/json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentRequestDTO" } },
              "application/*+json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentRequestDTO" } } } },
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/GenerateDocumentResponseDTOResponseAffinities" } } } } } } },
      "/api/affinities/GetProductConfiguration":{ get:{ tags:[ "Products" ],
          summary:"Returns the configuration for a given product",
          parameters:[ { name:"product",
              "in":"query",
              description:"",
              schema:{ type:"string" } },
            { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/ProductConfigurationDTOResponseAffinities" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/ProductConfigurationDTOResponseAffinities" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/ProductConfigurationDTOResponseAffinities" } } } } } } },
      "/api/underwriting/CreateRequest":{ post:{ tags:[ "Quotes" ],
          summary:"Create a new request based on input data. Returns Quote IDs for later update.",
          parameters:[ { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          requestBody:{ description:"",
            content:{ "application/json-patch+json":{ schema:{ $ref:"#/components/schemas/CreateRequestDTO" } },
              "application/json":{ schema:{ $ref:"#/components/schemas/CreateRequestDTO" } },
              "text/json":{ schema:{ $ref:"#/components/schemas/CreateRequestDTO" } },
              "application/*+json":{ schema:{ $ref:"#/components/schemas/CreateRequestDTO" } } } },
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/ResponseCreateRequestUnderwritingDTOResponseUnderwriting" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/ResponseCreateRequestUnderwritingDTOResponseUnderwriting" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/ResponseCreateRequestUnderwritingDTOResponseUnderwriting" } } } } } } },
      "/api/underwriting/SaveQuote":{ post:{ tags:[ "Quotes" ],
          summary:"Update a quote based on the input data. Returns Quote IDs and premium values.",
          parameters:[ { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          requestBody:{ description:"",
            content:{ "application/json-patch+json":{ schema:{ $ref:"#/components/schemas/SaveQuoteDTO" } },
              "application/json":{ schema:{ $ref:"#/components/schemas/SaveQuoteDTO" } },
              "text/json":{ schema:{ $ref:"#/components/schemas/SaveQuoteDTO" } },
              "application/*+json":{ schema:{ $ref:"#/components/schemas/SaveQuoteDTO" } } } },
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/ResponseSaveQuoteUnderwritingDTOResponseUnderwriting" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/ResponseSaveQuoteUnderwritingDTOResponseUnderwriting" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/ResponseSaveQuoteUnderwritingDTOResponseUnderwriting" } } } } } } },
      "/api/underwriting/GetExampleToSaveQuote":{ get:{ tags:[ "Quotes" ],
          summary:"Get an example object to SaveQuote endpoint. Only from quotes modified by the user.",
          parameters:[ { name:"quoteID",
              "in":"query",
              description:"",
              schema:{ type:"integer",
                format:"int32" } },
            { name:"quoteNumber",
              "in":"query",
              description:"",
              schema:{ type:"integer",
                format:"int32" } },
            { name:"X-Branch",
              "in":"header" },
            { name:"X-ApiKey",
              "in":"header" },
            { name:"X-Version",
              "in":"header" } ],
          responses:{ 200:{ description:"OK",
              content:{ "text/plain":{ schema:{ $ref:"#/components/schemas/SaveQuoteDTOResponseUnderwriting" } },
                "application/json":{ schema:{ $ref:"#/components/schemas/SaveQuoteDTOResponseUnderwriting" } },
                "text/json":{ schema:{ $ref:"#/components/schemas/SaveQuoteDTOResponseUnderwriting" } } } } } } } },
    components:{ schemas:{ ActivateButtonsResultDTO:{ type:"object",
          properties:{ informacionControles:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ControlInformation" } },
            changeDates:{ $ref:"#/components/schemas/ChangeDateDTO" },
            premiumControlList:{ $ref:"#/components/schemas/PremiumControlList" } },
          additionalProperties:false },
        ActivateButtonsResultDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/ActivateButtonsResultDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        ActuarialPricingFormula:{ type:"object",
          properties:{ id:{ type:"integer",
              format:"int32" },
            producto:{ type:[ "string",
                "null" ] },
            formula:{ type:[ "string",
                "null" ] },
            autoCalculation:{ type:"boolean" },
            f_Modif:{ type:"string",
              format:"date-time" },
            usr_Modif:{ type:[ "string",
                "null" ] },
            observaciones:{ type:[ "string",
                "null" ] },
            f_Version:{ type:"string",
              format:"date-time" } },
          additionalProperties:false },
        Adm_UsuariosDTO:{ type:"object",
          properties:{ usuario:{ type:[ "string",
                "null" ] },
            idioma:{ type:[ "string",
                "null" ] },
            dni:{ type:[ "string",
                "null" ] },
            filtro_poliza:{ type:[ "string",
                "null" ] },
            filtro_Corredor:{ type:[ "string",
                "null" ] },
            suscriptor:{ type:[ "string",
                "null" ] },
            nivelSeguridad:{ type:[ "integer",
                "null" ],
              format:"int32" } },
          additionalProperties:false },
        AlertValidatableWarning:{ type:"object",
          properties:{ alertType:{ type:[ "string",
                "null" ] },
            alertId:{ type:[ "string",
                "null" ] },
            errorMessage:{ $ref:"#/components/schemas/ErrorMessage" } },
          additionalProperties:false },
        AlertasCotizaciones:{ type:"object",
          properties:{ iD_Cot:{ type:"integer",
              format:"int32" },
            nivel:{ type:"integer",
              format:"int32" },
            alerta:{ type:[ "string",
                "null" ] },
            responsable:{ type:[ "string",
                "null" ] },
            poliza:{ type:[ "integer",
                "null" ],
              format:"int32" },
            fechaSolicitud:{ type:[ "string",
                "null" ],
              format:"date-time" },
            loB:{ type:[ "string",
                "null" ] },
            cliente:{ type:[ "string",
                "null" ] },
            corredor:{ type:[ "string",
                "null" ] },
            oficina:{ type:[ "string",
                "null" ] },
            suscriptor:{ type:[ "string",
                "null" ] },
            estado:{ type:[ "integer",
                "null" ],
              format:"int32" },
            capital:{ type:[ "number",
                "null" ],
              format:"double" },
            prima:{ type:[ "number",
                "null" ],
              format:"double" },
            comision:{ type:[ "number",
                "null" ],
              format:"float" },
            validable:{ type:"boolean" },
            info:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        AuditDTO:{ type:"object",
          properties:{ iD_Log:{ type:[ "integer",
                "null" ],
              format:"int32" },
            usuarioSolicita:{ type:[ "string",
                "null" ] },
            usuarioUltimaModificacion:{ type:[ "string",
                "null" ] },
            usuarioModificacion:{ type:[ "string",
                "null" ] },
            usuarioComercial:{ type:[ "string",
                "null" ] },
            usuarioAprobacion:{ type:[ "string",
                "null" ] },
            fechaModificacion:{ type:[ "string",
                "null" ],
              format:"date-time" },
            necesitaAutorizacion:{ type:"boolean" },
            permisosAdministrador:{ type:"boolean" } },
          additionalProperties:false },
        AuthorizationResponseDTO:{ type:"object",
          properties:{ resultado:{ type:"boolean" },
            mensajePopup:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        AuthorizationResponseDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/AuthorizationResponseDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        Automatic_Process_ServicesDTO:{ type:"object",
          properties:{ action:{ type:[ "string",
                "null" ] },
            name:{ type:[ "string",
                "null" ] },
            value:{ type:[ "string",
                "null" ] },
            suscriptor:{ type:[ "string",
                "null" ] },
            tipo:{ type:[ "string",
                "null" ] },
            patron:{ type:[ "string",
                "null" ] },
            mensaje:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Comerciales:{ type:"object",
          properties:{ valor:{ type:[ "string",
                "null" ] },
            descripcion:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Corredores:{ type:"object",
          properties:{ nombre_Largo:{ type:[ "string",
                "null" ] },
            nombre:{ type:[ "string",
                "null" ] },
            domicilio:{ type:[ "string",
                "null" ] },
            cod_Postal:{ type:[ "string",
                "null" ] },
            telefono_1:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] },
            localidad:{ type:[ "string",
                "null" ] },
            id:{ type:[ "string",
                "null" ] },
            autorizadoDGS:{ type:"boolean" },
            autorizadoASF:{ type:"boolean" },
            id_Estado:{ type:[ "string",
                "null" ] },
            especial:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Entidades:{ type:"object",
          properties:{ cod:{ type:"integer",
              format:"int32" },
            tipo:{ type:[ "string",
                "null" ] },
            entidad:{ type:[ "string",
                "null" ] },
            nombreLargo:{ type:[ "string",
                "null" ] },
            cif:{ type:[ "string",
                "null" ] },
            contacto:{ type:[ "string",
                "null" ] },
            telefono:{ type:[ "string",
                "null" ] },
            fax:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] },
            direccion1:{ type:[ "string",
                "null" ] },
            direccion2:{ type:[ "string",
                "null" ] },
            direccion3:{ type:[ "string",
                "null" ] },
            envioConsorcio:{ type:[ "boolean",
                "null" ] },
            iban:{ type:[ "string",
                "null" ] },
            ccc:{ type:[ "string",
                "null" ] },
            emailCC:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_IndustryCode:{ type:"object",
          properties:{ id:{ type:"integer",
              format:"int32" },
            code:{ type:[ "string",
                "null" ] },
            descripcion:{ type:[ "string",
                "null" ] },
            levelId:{ type:"integer",
              format:"int32" } },
          additionalProperties:false },
        Aux_Legal_Entities:{ type:"object",
          properties:{ id:{ type:"integer",
              format:"int32" },
            nombre:{ type:[ "string",
                "null" ] },
            nombre_Largo:{ type:[ "string",
                "null" ] },
            descripcion:{ type:[ "string",
                "null" ] },
            moneda_Defecto:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Listas:{ type:"object",
          properties:{ lista:{ type:[ "string",
                "null" ] },
            orden:{ type:"integer",
              format:"int32" },
            valor:{ type:[ "string",
                "null" ] },
            descripcion:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Listas_WithName:{ type:"object",
          properties:{ nombre:{ type:[ "string",
                "null" ] },
            lista:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Listas" } } },
          additionalProperties:false },
        Aux_Localidades:{ type:"object",
          properties:{ nombre:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Motivos_Suplementos:{ type:"object",
          properties:{ codigo:{ type:[ "string",
                "null" ] },
            descripcion:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Oficinas:{ type:"object",
          properties:{ siglas:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Oficinas_Corredor:{ type:"object",
          properties:{ registro_cia:{ type:[ "string",
                "null" ] },
            oficina:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Paises:{ type:"object",
          properties:{ id:{ type:[ "string",
                "null" ] },
            nombre:{ type:[ "string",
                "null" ] },
            orden:{ type:"integer",
              format:"int32" } },
          additionalProperties:false },
        Aux_Profit_Centers:{ type:"object",
          properties:{ id:{ type:"integer",
              format:"int32" },
            nombre:{ type:[ "string",
                "null" ] },
            nombre_Largo:{ type:[ "string",
                "null" ] },
            descripcion:{ type:[ "string",
                "null" ] },
            cia:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Suscriptores:{ type:"object",
          properties:{ codigo:{ type:[ "string",
                "null" ] },
            nombre:{ type:[ "string",
                "null" ] },
            codigo2:{ type:[ "integer",
                "null" ],
              format:"int32" },
            codigo3:{ type:[ "string",
                "null" ] },
            titulo:{ type:[ "string",
                "null" ] },
            telefono:{ type:[ "string",
                "null" ] },
            movil:{ type:[ "string",
                "null" ] },
            paginaWeb:{ type:[ "string",
                "null" ] },
            direccion:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Aux_Zona_Corredores:{ type:"object",
          properties:{ zona:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        AuxiliarData:{ type:"object",
          properties:{ n_CotizacionOrigen:{ type:[ "integer",
                "null" ],
              format:"int32" },
            modoPagina:{ type:[ "string",
                "null" ] },
            emitiendo:{ type:"boolean" },
            conCorredorSecundario:{ type:"boolean" },
            corredorSecundarioCodigoControl:{ type:[ "integer",
                "null" ],
              format:"int32" },
            capitalControl:{ type:[ "number",
                "null" ],
              format:"double" },
            agregadoControl:{ type:[ "number",
                "null" ],
              format:"double" },
            accion:{ type:[ "string",
                "null" ] },
            siniestrosAbiertos:{ type:"boolean" },
            databaseAlerts:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/AlertasCotizaciones" } },
            languageTo:{ type:[ "string",
                "null" ] },
            appName:{ type:[ "string",
                "null" ] },
            textoSuplementoTraducido:{ type:[ "string",
                "null" ] },
            brokerDataControl:{ $ref:"#/components/schemas/BrokerDataForQuoteValidation" },
            cantidadPolizasControl:{ type:[ "integer",
                "null" ],
              format:"int32" },
            estadoActualEnBase:{ type:[ "integer",
                "null" ],
              format:"int32" },
            estadoCodigo:{ type:[ "string",
                "null" ] },
            estadoDescripcion:{ type:[ "string",
                "null" ] },
            defaultCurrency:{ type:[ "string",
                "null" ] },
            quoteTitle:{ type:[ "string",
                "null" ] },
            n_CotizacionEmision:{ type:"integer",
              format:"int32" },
            suplementoRenovableVisible:{ type:"boolean" },
            cambioPorComplexPricing:{ type:"boolean" },
            pantallaOrigen:{ type:[ "string",
                "null" ] },
            hostOrigen:{ type:[ "string",
                "null" ] },
            iD_Risk:{ type:[ "integer",
                "null" ],
              format:"int32" },
            aptoParaFirmaDigital:{ type:"boolean" },
            cambioPorTipoCalculoReciboAdaptado:{ type:"boolean" },
            autorizacionesNT:{ type:[ "string",
                "null" ] },
            usuarioAutoriza:{ type:[ "string",
                "null" ] },
            usuarioAutorizaTexto:{ type:[ "string",
                "null" ] },
            motivoSuplementoTexto:{ type:[ "string",
                "null" ] },
            productoDescripcion:{ type:[ "string",
                "null" ] },
            actividadTexto:{ type:[ "string",
                "null" ] },
            idCompaniaBerkley:{ type:"integer",
              format:"int32" } },
          additionalProperties:false },
        BooleanResponse:{ type:"object",
          properties:{ data:{ type:"boolean" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        BrokerDataForQuoteValidation:{ type:"object",
          properties:{ autorizadoDGS:{ type:"boolean" },
            autorizadoASF:{ type:"boolean" },
            idEstado:{ type:[ "string",
                "null" ] },
            especial:{ type:"boolean" } },
          additionalProperties:false },
        ChangeDateDTO:{ type:"object",
          properties:{ fechaInicio:{ type:"string",
              format:"date-time" },
            horaInicio:{ type:[ "string",
                "null" ] },
            fechaVencimiento:{ type:"string",
              format:"date-time" },
            horaVencimiento:{ type:[ "string",
                "null" ] },
            fechaRetro:{ type:[ "string",
                "null" ],
              format:"date-time" } },
          additionalProperties:false },
        ClientPostDTO:{ type:"object",
          properties:{ name:{ type:[ "string",
                "null" ] },
            tin:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] },
            phone:{ type:[ "string",
                "null" ] },
            address:{ type:[ "string",
                "null" ] },
            city:{ type:[ "string",
                "null" ] },
            postalCode:{ type:[ "string",
                "null" ] },
            province:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        CoinsuranceDetailDTO:{ type:"object",
          properties:{ polizaAbridora:{ type:[ "string",
                "null" ] },
            impuestosLiquidos:{ type:[ "number",
                "null" ],
              format:"double" },
            comisionLiquida:{ type:[ "number",
                "null" ],
              format:"double" },
            primaLiquida:{ type:[ "number",
                "null" ],
              format:"double" },
            participacion:{ type:[ "number",
                "null" ],
              format:"double" },
            comisionAdministracion:{ type:[ "number",
                "null" ],
              format:"float" },
            distribution:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/CoinsuranceDistributionDTO" } } },
          additionalProperties:false },
        CoinsuranceDistributionDTO:{ type:"object",
          properties:{ compania:{ type:"integer",
              format:"int32" },
            iD_Ctto:{ type:"integer",
              format:"int32" },
            lider:{ type:"boolean" },
            part_Cia:{ type:[ "number",
                "null" ],
              format:"double" },
            comision:{ type:[ "number",
                "null" ],
              format:"double" },
            entidad:{ type:[ "string",
                "null" ] },
            entidadDescripcion:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        ComboCorredorDTO:{ type:"object",
          properties:{ toolTip:{ type:[ "array",
                "null" ],
              items:{ type:"string" } },
            oficinasCorredores:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Oficinas_Corredor" } },
            zonaCorredores:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Zona_Corredores" } },
            comerciales:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Comerciales" } } },
          additionalProperties:false },
        ComboCorredorDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/ComboCorredorDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        Common_Functions_ServicesDTO:{ type:"object",
          properties:{ action:{ type:[ "string",
                "null" ] },
            name:{ type:[ "string",
                "null" ] },
            value:{ type:[ "string",
                "null" ] },
            mensaje:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        ControlInformation:{ type:"object",
          properties:{ selector:{ type:[ "string",
                "null" ] },
            text:{ type:[ "string",
                "null" ] },
            visible:{ type:[ "boolean",
                "null" ] },
            enabled:{ type:[ "boolean",
                "null" ] },
            placeholder:{ type:[ "string",
                "null" ] },
            listName:{ type:[ "string",
                "null" ] },
            onClick:{ type:[ "string",
                "null" ] },
            value:{ type:[ "string",
                "null" ] },
            valueDate:{ type:[ "string",
                "null" ],
              format:"date-time" },
            href:{ type:[ "string",
                "null" ] },
            dataType:{ type:[ "string",
                "null" ] },
            listItems:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/SelectListItem" } } },
          additionalProperties:false },
        ControlInformationIEnumerableResponse:{ type:"object",
          properties:{ data:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ControlInformation" } },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        ControladorQueryDTO:{ type:"object",
          properties:{ id:{ type:[ "string",
                "null" ] },
            codigo:{ type:[ "string",
                "null" ] },
            sql:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        ControladorQueryRespuestaDTO:{ type:"object",
          properties:{ id:{ type:[ "string",
                "null" ] },
            codigo:{ type:[ "string",
                "null" ] },
            sqL_Original:{ type:[ "string",
                "null" ] },
            respuesta:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        ControladorQueryRespuestaDTOIEnumerableResponse:{ type:"object",
          properties:{ data:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ControladorQueryRespuestaDTO" } },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        Coverage:{ type:"object",
          properties:{ cobertura:{ type:[ "string",
                "null" ] },
            limite:{ type:[ "string",
                "null" ] },
            codigo:{ type:[ "string",
                "null" ] },
            orden:{ type:"integer",
              format:"int32" },
            coverageDescription:{ type:[ "string",
                "null" ] },
            limitDescription:{ type:[ "string",
                "null" ] },
            tipo:{ type:[ "string",
                "null" ] },
            coverageType:{ $ref:"#/components/schemas/CoverageTypeEnum" },
            fieldType:{ $ref:"#/components/schemas/FieldTypeEnum" },
            unidades:{ type:[ "string",
                "null" ] },
            valor:{ type:[ "string",
                "null" ] },
            valores:{ type:[ "string",
                "null" ] },
            exceedsMain:{ type:"boolean" },
            isOptional:{ type:"boolean" },
            isFixed:{ type:"boolean" },
            isCapital:{ type:"boolean" },
            isPrincipal:{ type:"boolean" },
            multiRisk:{ type:"boolean" },
            formula:{ type:[ "string",
                "null" ] },
            tipo_Campo:{ type:[ "string",
                "null" ] },
            porDefecto:{ type:[ "string",
                "null" ] },
            tipoCob:{ type:[ "string",
                "null" ] },
            esVisible:{ type:[ "string",
                "null" ] },
            tipoRiesgo:{ type:"integer",
              format:"int32" },
            rateIncrease:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        CoverageAnswerDTO:{ type:"object",
          properties:{ cobertura:{ type:[ "string",
                "null" ] },
            limite:{ type:[ "string",
                "null" ] },
            codigo:{ type:[ "string",
                "null" ] },
            respuesta:{ type:[ "string",
                "null" ] },
            tipoCampo:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        CoverageResponseDTO:{ type:"object",
          properties:{ order:{ type:"integer",
              format:"int32" },
            coverageDescription:{ type:[ "string",
                "null" ] },
            limitDescription:{ type:[ "string",
                "null" ] },
            value:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        CoverageTypeEnum:{ "enum":[ 0,
            1,
            2,
            3,
            4,
            5,
            6,
            7 ],
          type:"integer",
          format:"int32" },
        CreateQuoteAffinitiesResponseDTO:{ type:"object",
          properties:{ quoteId:{ type:[ "string",
                "null" ] },
            quoteNumber:{ type:[ "string",
                "null" ] },
            premiumDetail:{ $ref:"#/components/schemas/PremiumResponseDTO" },
            coverages:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/CoverageResponseDTO" } },
            errors:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        CreateQuoteAffinitiesResponseDTOResponseAffinities:{ type:"object",
          properties:{ isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            data:{ $ref:"#/components/schemas/CreateQuoteAffinitiesResponseDTO" },
            errorModel:{ $ref:"#/components/schemas/ErrorModelAffinities" } },
          additionalProperties:false },
        CreateRequestDTO:{ type:"object",
          properties:{ detail:{ $ref:"#/components/schemas/CreateRequestDetailDTO" },
            policyHolder:{ $ref:"#/components/schemas/SaveQuotePolicyholderDTO" } },
          additionalProperties:false },
        CreateRequestDetailDTO:{ type:"object",
          properties:{ loB:{ type:[ "string",
                "null" ] },
            productCode:{ type:[ "string",
                "null" ] },
            riskSubtypeActivityCode:{ type:"integer",
              format:"int32" },
            activityCode:{ type:[ "string",
                "null" ] },
            "package":{ type:[ "string",
                "null" ] },
            brokerCode:{ type:[ "integer",
                "null" ],
              format:"int32" },
            brokerEmail:{ type:[ "string",
                "null" ] },
            brokerContact:{ type:[ "string",
                "null" ] },
            underwriter:{ type:[ "string",
                "null" ] },
            canal:{ type:[ "string",
                "null" ] },
            legalEntity:{ type:"integer",
              format:"int32" },
            profitCenter:{ type:[ "integer",
                "null" ],
              format:"int32" },
            office:{ type:[ "string",
                "null" ] },
            officeBrokerCode:{ type:[ "integer",
                "null" ],
              format:"int32" },
            industryCodeID:{ type:[ "integer",
                "null" ],
              format:"int32" },
            originalCurrency:{ type:[ "string",
                "null" ] },
            brokerAgreementID:{ type:[ "integer",
                "null" ],
              format:"int32" },
            bussinessType:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        CredentialsDTO:{ required:[ "password",
            "userName" ],
          type:"object",
          properties:{ userName:{ minLength:1,
              type:"string" },
            password:{ minLength:1,
              type:"string" } },
          additionalProperties:false },
        Currency:{ type:"object",
          properties:{ id:{ type:[ "string",
                "null" ] },
            nombre:{ type:[ "string",
                "null" ] },
            defaultValue:{ type:"boolean" } },
          additionalProperties:false },
        DecimalDateTimeTuple:{ type:"object",
          properties:{ item1:{ type:"number",
              format:"double" },
            item2:{ type:"string",
              format:"date-time" } },
          additionalProperties:false },
        DecimalDateTimeTupleResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/DecimalDateTimeTuple" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        DocumentManagementPostDTO:{ type:"object",
          properties:{ generateDocument:{ type:"boolean" },
            sendingMethod:{ type:[ "string",
                "null" ] },
            sendingAddress:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        DocumentatinDTO:{ type:"object",
          properties:{ iD_Cot:{ type:"integer",
              format:"int32" },
            n_Cotizacion:{ type:"integer",
              format:"int32" },
            clausulaAclaratoria:{ type:[ "string",
                "null" ] },
            condicionesEspeciales:{ type:[ "integer",
                "null" ],
              format:"int32" },
            fechaCondicionesEspeciales:{ type:[ "string",
                "null" ],
              format:"date-time" },
            condicionesGenerales:{ type:[ "integer",
                "null" ],
              format:"int32" },
            fechaCondicionesGenerales:{ type:[ "string",
                "null" ],
              format:"date-time" },
            listadoAsegurados:{ type:[ "integer",
                "null" ],
              format:"int32" },
            fechaListadoAsegurados:{ type:[ "string",
                "null" ],
              format:"date-time" } },
          additionalProperties:false },
        ErrorCodeEnum:{ "enum":[ 1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9 ],
          type:"integer",
          format:"int32" },
        ErrorMessage:{ type:"object",
          properties:{ type:{ $ref:"#/components/schemas/ErrorType" },
            message:{ type:[ "string",
                "null" ] },
            messageTranslation:{ $ref:"#/components/schemas/TranslatedString" },
            messageParameters:{ type:[ "array",
                "null" ],
              items:{ type:"string" } },
            errorServer:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        ErrorModel:{ type:"object",
          properties:{ warnings:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/WarningMessage" } },
            alertValidatables:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/AlertValidatableWarning" } },
            errors:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ErrorMessage" } },
            isValid:{ type:"boolean",
              readOnly:true },
            errorCode:{ $ref:"#/components/schemas/ErrorCodeEnum" } },
          additionalProperties:false },
        ErrorModelAffinities:{ type:"object",
          properties:{ isValid:{ type:"boolean",
              readOnly:true },
            warnings:{ type:[ "array",
                "null" ],
              items:{ type:"string" } },
            errors:{ type:[ "array",
                "null" ],
              items:{ type:"string" } },
            htmlFormat:{ type:[ "string",
                "null" ],
              readOnly:true } },
          additionalProperties:false },
        ErrorModelUnderwriting:{ type:"object",
          properties:{ isValid:{ type:"boolean",
              readOnly:true },
            warnings:{ type:[ "array",
                "null" ],
              items:{ type:"string" } },
            errors:{ type:[ "array",
                "null" ],
              items:{ type:"string" } },
            htmlFormat:{ type:[ "string",
                "null" ],
              readOnly:true } },
          additionalProperties:false },
        ErrorType:{ "enum":[ 0,
            1 ],
          type:"integer",
          format:"int32" },
        ExpositionDTO:{ type:"object",
          properties:{ capital:{ type:[ "number",
                "null" ],
              format:"double" },
            isCapitalEdit:{ type:"boolean" },
            agregado:{ type:[ "number",
                "null" ],
              format:"double" },
            isAgregadoEdit:{ type:"boolean" },
            isAgregadoView:{ type:"boolean" },
            limitePorVictima:{ type:[ "number",
                "null" ],
              format:"double" } },
          additionalProperties:false },
        FieldTypeEnum:{ "enum":[ 0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15 ],
          type:"integer",
          format:"int32" },
        GenerateDocumentRequestDTO:{ type:"object",
          properties:{ quoteIdentification:{ $ref:"#/components/schemas/QuoteIdentificationAffinitiesDTO" },
            docType:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        GenerateDocumentResponseDTO:{ type:"object",
          properties:{ document:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        GenerateDocumentResponseDTOResponseAffinities:{ type:"object",
          properties:{ isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            data:{ $ref:"#/components/schemas/GenerateDocumentResponseDTO" },
            errorModel:{ $ref:"#/components/schemas/ErrorModelAffinities" } },
          additionalProperties:false },
        HealthStatusEnum:{ "enum":[ 0,
            1,
            2 ],
          type:"integer",
          format:"int32" },
        HealthStatusEnumResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/HealthStatusEnum" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        InitialDataForBeitsPageDTO:{ type:"object",
          properties:{ quoteInitialData:{ $ref:"#/components/schemas/QuoteInitialDataDTO" },
            producto:{ $ref:"#/components/schemas/Product" },
            coberturasOpcionales:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/OptionalCoverage" } },
            validaciones:{ $ref:"#/components/schemas/QuoteAlertsDTO" },
            informacionControles:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ControlInformation" } },
            paises:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Paises" } },
            vismaPaises:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Paises" } },
            corredores:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Corredores" } },
            corredoresGrupoCOS:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Corredores" } },
            profitCenters:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Profit_Centers" } },
            legalEntities:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Legal_Entities" } },
            monedas:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Currency" } },
            oficinas:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Oficinas" } },
            motivosSuplementos:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Motivos_Suplementos" } },
            motivosSuplementosRenovacion:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Motivos_Suplementos" } },
            listas:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Listas_WithName" } },
            actividades:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Ptos_Condicionados" } },
            industryCode:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_IndustryCode" } },
            suscriptores:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Suscriptores" } },
            localidades:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Localidades" } },
            traduccionesAuxiliares:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/TranslatedString" } },
            entidadesCia:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Aux_Entidades" } },
            coaseguro_IdCompaniaBerkley:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        InitialDataForBeitsPageDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/InitialDataForBeitsPageDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        InstallmentDTO:{ type:"object",
          properties:{ iD_Cot:{ type:"integer",
              format:"int32" },
            n_Cotizacion:{ type:"integer",
              format:"int32" },
            n_Periodo:{ type:"integer",
              format:"int32" },
            f_Efecto_Rec:{ type:[ "string",
                "null" ],
              format:"date-time" },
            prima:{ type:[ "number",
                "null" ],
              format:"double" },
            recargo_Fraccto:{ type:[ "number",
                "null" ],
              format:"double" },
            impuestos:{ type:[ "number",
                "null" ],
              format:"double" },
            clea:{ type:[ "number",
                "null" ],
              format:"double" },
            consorcio:{ type:[ "number",
                "null" ],
              format:"double" },
            tributos:{ type:[ "number",
                "null" ],
              format:"double" },
            otros_Impuestos:{ type:[ "number",
                "null" ],
              format:"double" },
            prima_Recibo:{ type:[ "number",
                "null" ],
              format:"double" },
            basePrima:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        IssueDTO:{ type:"object",
          properties:{ idCotizacion:{ type:"integer",
              format:"int32" },
            nroCotizacion:{ type:"integer",
              format:"int32" },
            documentos:{ type:"boolean" },
            pantallaOrigen:{ type:[ "string",
                "null" ] },
            hostOrigen:{ type:[ "string",
                "null" ] },
            idPais:{ type:[ "integer",
                "null" ],
              format:"int32" },
            idSup:{ type:[ "integer",
                "null" ],
              format:"int32" },
            idMarco:{ type:[ "integer",
                "null" ],
              format:"int32" },
            selectorDocumentosVisible:{ type:"boolean" },
            listaDocumentosSeleccionados:{ type:[ "string",
                "null" ] },
            emitirRecibos:{ type:"boolean" },
            motivoSuplemento:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        IssuePolicyPostDTO:{ type:"object",
          properties:{ quoteIdentification:{ $ref:"#/components/schemas/QuoteIdentificationAffinitiesDTO" },
            digitalSignature:{ type:"boolean" },
            documentManagement:{ $ref:"#/components/schemas/DocumentManagementPostDTO" } },
          additionalProperties:false },
        IssueResponseDTO:{ type:"object",
          properties:{ idCotizacion:{ type:[ "string",
                "null" ] },
            nroCotizacion:{ type:[ "string",
                "null" ] },
            id_Susc:{ type:[ "integer",
                "null" ],
              format:"int32" },
            id_Marco:{ type:[ "integer",
                "null" ],
              format:"int32" },
            urlRedirect:{ type:[ "string",
                "null" ] },
            validaciones:{ $ref:"#/components/schemas/QuoteAlertsDTO" } },
          additionalProperties:false },
        IssueResponseDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/IssueResponseDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        ListConfigDTO:{ type:"object",
          properties:{ listId:{ type:[ "string",
                "null" ] },
            items:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/SelectListItemDTO" } } },
          additionalProperties:false },
        OptionalCoverage:{ type:"object",
          properties:{ cobertura:{ type:[ "string",
                "null" ] },
            esVisible:{ type:[ "string",
                "null" ] },
            desc_Cobertura:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PaymentConfigurationDTO:{ type:"object",
          properties:{ paymentType:{ type:[ "string",
                "null" ] },
            paymentMethod:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PaymentManagementDTO:{ type:"object",
          properties:{ gestionCobro:{ type:[ "string",
                "null" ] },
            formaDePago:{ type:[ "string",
                "null" ] },
            iban:{ type:[ "string",
                "null" ] },
            ccc:{ type:[ "string",
                "null" ] },
            nroPlazos:{ type:[ "integer",
                "null" ],
              format:"int32" } },
          additionalProperties:false },
        PaymentPostDTO:{ type:"object",
          properties:{ type:{ type:[ "string",
                "null" ] },
            paymentMethod:{ type:[ "string",
                "null" ] },
            iban:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PolicyHolderDTO:{ type:"object",
          properties:{ cliente:{ type:[ "string",
                "null" ] },
            nif:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] },
            telefono:{ type:[ "string",
                "null" ] },
            iD_Pais:{ type:[ "integer",
                "null" ],
              format:"int32" },
            provincia:{ type:[ "string",
                "null" ] },
            localidad:{ type:[ "string",
                "null" ] },
            direccion:{ type:[ "string",
                "null" ] },
            codPostal:{ type:[ "string",
                "null" ] },
            segundaDireccion:{ $ref:"#/components/schemas/SecondAddressDTO" } },
          additionalProperties:false },
        PolicyHolderPDTO:{ type:"object",
          properties:{ tomador:{ type:[ "string",
                "null" ] },
            direccion:{ type:[ "string",
                "null" ] },
            calle:{ type:[ "string",
                "null" ] },
            localidad:{ type:[ "string",
                "null" ] },
            provincia:{ type:[ "string",
                "null" ] },
            cod_Postal:{ type:[ "string",
                "null" ] },
            pais:{ type:[ "string",
                "null" ] },
            cod_Pais:{ type:"integer",
              format:"int32" },
            cif:{ type:[ "string",
                "null" ] },
            id:{ type:"integer",
              format:"int32" },
            tipo:{ type:[ "string",
                "null" ] },
            nombre:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PolicyHolderPDTOListResponse:{ type:"object",
          properties:{ data:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/PolicyHolderPDTO" } },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        PolicyResponseDTO:{ type:"object",
          properties:{ quoteId:{ type:"integer",
              format:"int32" },
            quoteNumber:{ type:"integer",
              format:"int32" },
            idPolicy:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PolicyResponseDTOResponseAffinities:{ type:"object",
          properties:{ isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            data:{ $ref:"#/components/schemas/PolicyResponseDTO" },
            errorModel:{ $ref:"#/components/schemas/ErrorModelAffinities" } },
          additionalProperties:false },
        PremiumCalculationResultDTO:{ type:"object",
          properties:{ tarifa:{ $ref:"#/components/schemas/PremiumCalculationResultDTO_Tariff" },
            anioActual:{ $ref:"#/components/schemas/PremiumCalculationResultDTO_CurrentYear" },
            suplemento:{ $ref:"#/components/schemas/PremiumCalculationResultDTO_Endorsement" },
            primaRenovacion:{ $ref:"#/components/schemas/PremiumCalculationResultDTO_RenewalPremium" },
            validaciones:{ $ref:"#/components/schemas/QuoteAlertsDTO" },
            fraccionamientos:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/InstallmentDTO" } },
            detallePricing:{ $ref:"#/components/schemas/PricingDetailDTO" },
            mostrarPrimaTecnica:{ type:"boolean" },
            anularRecibosAnteriores:{ type:[ "string",
                "null" ] },
            listaRecibosAnulados:{ type:[ "string",
                "null" ] },
            sinFraccionamiento:{ type:[ "string",
                "null" ] },
            sinRecibos:{ type:[ "string",
                "null" ] },
            fraccionamientoAdaptado:{ type:"boolean" },
            tipoCalculo:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PremiumCalculationResultDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/PremiumCalculationResultDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        PremiumCalculationResultDTO_CurrentYear:{ type:"object",
          properties:{ fechaEfecto:{ type:[ "string",
                "null" ],
              format:"date-time" },
            fechaVencimiento:{ type:[ "string",
                "null" ],
              format:"date-time" },
            porcentajeDescuento:{ type:"number",
              format:"double" },
            primaNeta:{ type:"number",
              format:"double" },
            recargo:{ type:"number",
              format:"double" },
            tax1:{ type:"number",
              format:"double" },
            tax2:{ type:"number",
              format:"double" },
            tax3:{ type:"number",
              format:"double" },
            tax4:{ type:"number",
              format:"double" },
            tax5:{ type:"number",
              format:"double" },
            primaTotal:{ type:"number",
              format:"double" },
            porcentajeComision:{ type:"number",
              format:"double" },
            comision:{ type:"number",
              format:"double" },
            primaNetaDeComision:{ type:"number",
              format:"double" },
            primaConRecargo:{ type:"number",
              format:"double",
              readOnly:true } },
          additionalProperties:false },
        PremiumCalculationResultDTO_Endorsement:{ type:"object",
          properties:{ fechaEfecto:{ type:[ "string",
                "null" ],
              format:"date-time" },
            fechaVencimiento:{ type:[ "string",
                "null" ],
              format:"date-time" },
            primaNeta:{ type:"number",
              format:"double" },
            recargo:{ type:"number",
              format:"double" },
            tax1:{ type:"number",
              format:"double" },
            tax2:{ type:"number",
              format:"double" },
            tax3:{ type:"number",
              format:"double" },
            tax4:{ type:"number",
              format:"double" },
            tax5:{ type:"number",
              format:"double" },
            primaTotal:{ type:"number",
              format:"double" },
            comision:{ type:"number",
              format:"double" },
            suplementoAnualizable:{ type:[ "string",
                "null" ] },
            suplementoRenovable:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PremiumCalculationResultDTO_RenewalPremium:{ type:"object",
          properties:{ sistemaAnioActual:{ type:"number",
              format:"double" },
            sistemaSuplemento:{ type:"number",
              format:"double" },
            suscriptor:{ type:"number",
              format:"double" },
            rateIncreaseDefecto:{ type:"number",
              format:"double" },
            rateIncreaseSuscriptor:{ type:"number",
              format:"double" },
            primaRenovacion:{ type:"number",
              format:"double" },
            rateIncreaseDescripcion:{ type:[ "string",
                "null" ] },
            rateIncreaseErrores:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PremiumCalculationResultDTO_Tariff:{ type:"object",
          properties:{ primaTecnica:{ type:"number",
              format:"double" },
            descuentoAcuerdo:{ type:"number",
              format:"double" },
            primaTarifaAnual:{ type:"number",
              format:"double" },
            primaTarifaProrrateada:{ type:"number",
              format:"double" } },
          additionalProperties:false },
        PremiumControlList:{ type:"object",
          properties:{ list:{ type:[ "string",
                "null" ] },
            "default":{ type:[ "string",
                "null" ] },
            control:{ type:[ "string",
                "null" ] },
            campoFijo:{ type:"boolean" } },
          additionalProperties:false },
        PremiumDetailDTO:{ type:"object",
          properties:{ basePrima:{ type:[ "string",
                "null" ] },
            prima:{ type:[ "number",
                "null" ],
              format:"double" },
            primaTarifa:{ type:[ "number",
                "null" ],
              format:"double" },
            primaTotal:{ type:[ "number",
                "null" ],
              format:"double" },
            primaAnualidad:{ type:[ "number",
                "null" ],
              format:"double" },
            primaRenovacion:{ type:[ "number",
                "null" ],
              format:"double" },
            primaRenovacionSuscriptor:{ type:[ "number",
                "null" ],
              format:"double" },
            primaTecnica:{ type:[ "number",
                "null" ],
              format:"double" },
            tax1:{ type:[ "number",
                "null" ],
              format:"double" },
            tax2:{ type:[ "number",
                "null" ],
              format:"double" },
            tax3:{ type:[ "number",
                "null" ],
              format:"double" },
            tax4:{ type:[ "number",
                "null" ],
              format:"double" },
            otrosImpuestos:{ type:[ "number",
                "null" ],
              format:"double" },
            comision:{ type:[ "number",
                "null" ],
              format:"double" },
            porcentajeComision:{ type:[ "number",
                "null" ],
              format:"double" },
            porcentajeDescuento:{ type:[ "number",
                "null" ],
              format:"double" },
            recargo:{ type:[ "number",
                "null" ],
              format:"double" },
            recargoEspecial:{ type:[ "number",
                "null" ],
              format:"double" },
            tasa:{ type:"number",
              format:"double" },
            tasaTarifa:{ type:[ "number",
                "null" ],
              format:"double" },
            part:{ type:[ "number",
                "null" ],
              format:"double" },
            comAdmon:{ type:[ "number",
                "null" ],
              format:"float" },
            enExceso:{ type:[ "number",
                "null" ],
              format:"double" },
            porcentajeDescuentoAcuerdo:{ type:[ "number",
                "null" ],
              format:"double" },
            expectedLoss:{ type:[ "number",
                "null" ],
              format:"double" },
            rateIncrease:{ type:[ "number",
                "null" ],
              format:"double" },
            rateIncreaseSuscriptor:{ type:[ "number",
                "null" ],
              format:"double" },
            tipoCalculo:{ type:[ "string",
                "null" ] },
            error:{ type:[ "string",
                "null" ] },
            acta:{ type:[ "string",
                "null" ] },
            opciones:{ type:[ "string",
                "null" ] },
            sobrescribirPrimaRenovacion:{ type:"boolean",
              readOnly:true },
            sobrescribirRateIncrease:{ type:"boolean",
              readOnly:true },
            suplementoRenovable:{ type:[ "string",
                "null" ] },
            suplementoAnualizable:{ type:[ "string",
                "null" ] },
            anularRecibosAnteriores:{ type:[ "string",
                "null" ] },
            listaRecibosAnulados:{ type:[ "string",
                "null" ] },
            sinFraccionamiento:{ type:[ "string",
                "null" ] },
            sinRecibos:{ type:[ "string",
                "null" ] },
            fraccionamientoAdaptado:{ type:"boolean" },
            tieneFraccionamientoAdaptado:{ type:"boolean" },
            primaRenovacionSuplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            primaSuplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            recargoSuplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            tax1Suplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            tax2Suplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            tax3Suplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            tax4Suplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            primaTotalSuplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            comisionSuplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            installments:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/InstallmentDTO" } } },
          additionalProperties:false },
        PremiumResponseDTO:{ type:"object",
          properties:{ premium:{ type:[ "number",
                "null" ],
              format:"double" },
            annualPremium:{ type:[ "number",
                "null" ],
              format:"double" },
            consortium:{ type:[ "number",
                "null" ],
              format:"double" },
            taxes:{ type:"number",
              format:"double",
              readOnly:true },
            totalPremium:{ type:"number",
              format:"double",
              readOnly:true } },
          additionalProperties:false },
        PricingDetailDTO:{ type:"object",
          properties:{ iD_Cot:{ type:"integer",
              format:"int32" },
            n_Cotizacion:{ type:"integer",
              format:"int32" },
            premiumTechnical:{ type:[ "number",
                "null" ],
              format:"double" },
            premiumTarget:{ type:[ "number",
                "null" ],
              format:"double" },
            expectedLoss:{ type:[ "number",
                "null" ],
              format:"double" },
            acta:{ type:[ "string",
                "null" ] },
            errors:{ type:[ "string",
                "null" ] },
            warnings:{ type:[ "string",
                "null" ] },
            pricingFormula:{ $ref:"#/components/schemas/ActuarialPricingFormula" },
            premiumByCoverages:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ControlInformation" } } },
          additionalProperties:false },
        PricingDetailDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/PricingDetailDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        ProblemDetails:{ type:"object",
          properties:{ type:{ type:[ "string",
                "null" ] },
            title:{ type:[ "string",
                "null" ] },
            status:{ type:[ "integer",
                "null" ],
              format:"int32" },
            detail:{ type:[ "string",
                "null" ] },
            instance:{ type:[ "string",
                "null" ] } },
          additionalProperties:{} },
        Prod_Coberturas:{ type:"object",
          properties:{ iD_cot:{ type:"integer",
              format:"int32" },
            n_Cotizacion:{ type:"integer",
              format:"int32" },
            cobertura:{ type:[ "string",
                "null" ] },
            limite:{ type:[ "string",
                "null" ] },
            valor:{ type:[ "string",
                "null" ] },
            n_Riesgo:{ type:"integer",
              format:"int32" },
            id:{ type:[ "string",
                "null" ] },
            respuesta:{ type:[ "string",
                "null" ] },
            codigo:{ type:[ "string",
                "null" ] },
            tipo_Campo:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Prod_Preguntas:{ type:"object",
          properties:{ iD_cot:{ type:"integer",
              format:"int32" },
            n_Cotizacion:{ type:"integer",
              format:"int32" },
            pregunta:{ type:[ "string",
                "null" ] },
            respuesta:{ type:[ "string",
                "null" ] },
            n_Riesgo:{ type:"integer",
              format:"int32" },
            n_Fila:{ type:"integer",
              format:"int32" },
            id:{ type:[ "string",
                "null" ] },
            iD_Pregunta:{ type:[ "string",
                "null" ] },
            objeto:{ type:[ "string",
                "null" ] },
            orden:{ type:"integer",
              format:"int32" },
            incluirEnCuestionario:{ type:[ "string",
                "null" ] },
            tipo_pregunta:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Product:{ type:"object",
          properties:{ loB:{ type:[ "string",
                "null" ] },
            loBMkt:{ type:[ "string",
                "null" ] },
            producto:{ type:[ "string",
                "null" ] },
            descripcion:{ type:[ "string",
                "null" ] },
            version:{ type:[ "string",
                "null" ],
              format:"date-time" },
            delimitacionTemp:{ type:[ "string",
                "null" ] },
            meses:{ type:[ "string",
                "null" ] },
            delimitacionGeo:{ type:[ "string",
                "null" ] },
            coaseguro:{ type:[ "string",
                "null" ] },
            reaseguro:{ type:[ "string",
                "null" ] },
            admonPublica:{ type:[ "string",
                "null" ] },
            ensayoClinico:{ type:[ "string",
                "null" ] },
            colectivo:{ type:[ "string",
                "null" ] },
            polizaEnExceso:{ type:[ "string",
                "null" ] },
            gestionCobro:{ type:[ "string",
                "null" ] },
            formaDePago:{ type:[ "string",
                "null" ] },
            aTermino:{ type:[ "string",
                "null" ] },
            recargoT:{ type:[ "number",
                "null" ],
              format:"double" },
            recargoS:{ type:[ "number",
                "null" ],
              format:"double" },
            capital:{ type:[ "string",
                "null" ] },
            agregado:{ type:[ "string",
                "null" ] },
            impuestos:{ type:[ "string",
                "null" ] },
            clea:{ type:[ "string",
                "null" ] },
            consorcio:{ type:[ "string",
                "null" ] },
            tributos:{ type:[ "string",
                "null" ] },
            tipoPoliza:{ type:[ "string",
                "null" ] },
            sqlPoliza:{ type:[ "string",
                "null" ] },
            sqlPolizaStr:{ type:[ "string",
                "null" ] },
            iD_Susc:{ type:[ "string",
                "null" ] },
            tipoPrima:{ type:[ "string",
                "null" ] },
            regularizableIPC:{ type:[ "string",
                "null" ] },
            pct_Com:{ type:[ "string",
                "null" ] },
            formula:{ type:[ "string",
                "null" ] },
            reglas:{ type:[ "string",
                "null" ] },
            coberturasOpcionales:{ type:[ "string",
                "null" ] },
            anchoTablaPreg:{ type:[ "integer",
                "null" ],
              format:"int32" },
            configuracion:{ type:[ "string",
                "null" ] },
            moneda_Orig:{ type:[ "string",
                "null" ] },
            suscriptor:{ type:[ "string",
                "null" ] },
            limite_Victima:{ type:[ "string",
                "null" ] },
            concurso:{ type:[ "string",
                "null" ] },
            legal_Entity:{ type:"integer",
              format:"int32" },
            profit_Center:{ type:"integer",
              format:"int32" },
            rate_Increase:{ type:"number",
              format:"double" },
            referal:{ type:[ "string",
                "null" ] },
            questions:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Question" } },
            coverages:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Coverage" } } },
          additionalProperties:false },
        ProductConfigurationDTO:{ type:"object",
          properties:{ product:{ type:[ "string",
                "null" ] },
            subRiskTypes:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/SubRiskTypeDTO" } },
            paymentManagement:{ $ref:"#/components/schemas/PaymentConfigurationDTO" },
            questions:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/QuestionDTO" } },
            lists:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ListConfigDTO" } } },
          additionalProperties:false },
        ProductConfigurationDTOResponseAffinities:{ type:"object",
          properties:{ isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            data:{ $ref:"#/components/schemas/ProductConfigurationDTO" },
            errorModel:{ $ref:"#/components/schemas/ErrorModelAffinities" } },
          additionalProperties:false },
        ProductsGenerateDocumentDTO:{ type:"object",
          properties:{ idCotizacion:{ type:[ "integer",
                "null" ],
              format:"int32" },
            nroCotizacion:{ type:[ "integer",
                "null" ],
              format:"int32" },
            tipoDocumento:{ type:[ "string",
                "null" ] },
            estadoCotizacion:{ type:[ "string",
                "null" ] },
            marcaWord:{ type:[ "string",
                "null" ] },
            idPais:{ type:[ "integer",
                "null" ],
              format:"int32" },
            pantallaOrigen:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Ptos_Condicionados:{ type:"object",
          properties:{ producto:{ type:[ "string",
                "null" ] },
            condicionado:{ type:[ "string",
                "null" ] },
            actividad:{ type:"integer",
              format:"int32" },
            pais:{ type:[ "string",
                "null" ] },
            subTipoRiesgo:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Question:{ type:"object",
          properties:{ producto:{ type:[ "string",
                "null" ] },
            iD_Pregunta:{ type:[ "string",
                "null" ] },
            orden:{ type:"integer",
              format:"int32" },
            tipo:{ $ref:"#/components/schemas/FieldTypeEnum" },
            pregunta:{ type:[ "string",
                "null" ] },
            opcionesCombo:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/SelectListItem" } },
            porDefecto:{ type:[ "string",
                "null" ] },
            unidades:{ type:[ "string",
                "null" ] },
            esObligatoria:{ type:[ "string",
                "null" ] },
            validacion:{ type:[ "string",
                "null" ] },
            multiRiesgo:{ type:"boolean" },
            ayuda:{ type:[ "string",
                "null" ] },
            esVisible:{ type:[ "string",
                "null" ] },
            tipo_pregunta:{ type:[ "string",
                "null" ] },
            valores:{ type:[ "string",
                "null" ] },
            ancho:{ type:[ "string",
                "null" ] },
            esAutoPostBack:{ type:[ "string",
                "null" ] },
            iD2_Pregunta:{ type:[ "string",
                "null" ] },
            tipoRiesgo:{ type:"integer",
              format:"int32" },
            isSection:{ type:"boolean" },
            objeto:{ type:[ "string",
                "null" ] },
            listId:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        QuestionAnswerDTO:{ type:"object",
          properties:{ iD_Pregunta:{ type:[ "string",
                "null" ] },
            respuesta:{ type:[ "string",
                "null" ] },
            numeroFila:{ type:[ "string",
                "null" ] },
            tipoCampo:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        QuestionDTO:{ type:"object",
          properties:{ questionId:{ type:[ "string",
                "null" ] },
            questionText:{ type:[ "string",
                "null" ] },
            listId:{ type:[ "string",
                "null" ] },
            isRequired:{ type:"boolean" },
            riskType:{ type:[ "integer",
                "null" ],
              format:"int32" },
            helpText:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        QuestionPostDTO:{ type:"object",
          properties:{ questionId:{ type:[ "string",
                "null" ] },
            answer:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        QuoteAlertsDTO:{ type:"object",
          properties:{ alertas:{ type:[ "string",
                "null" ] },
            errores:{ type:[ "string",
                "null" ] },
            avisosPreEmision:{ type:[ "string",
                "null" ] },
            especiales:{ type:[ "string",
                "null" ] },
            forzarVisibilidadModal:{ type:"boolean" } },
          additionalProperties:false },
        QuoteDatesDTO:{ type:"object",
          properties:{ solicitud:{ type:[ "string",
                "null" ],
              format:"date-time" },
            cotizacion:{ type:[ "string",
                "null" ],
              format:"date-time" },
            inicioPoliza:{ type:[ "string",
                "null" ],
              format:"date-time" },
            vencimientoPoliza:{ type:[ "string",
                "null" ],
              format:"date-time" },
            inicioSuplemento:{ type:[ "string",
                "null" ],
              format:"date-time" },
            vencimientoSuplemento:{ type:[ "string",
                "null" ],
              format:"date-time" },
            retro:{ type:[ "string",
                "null" ],
              format:"date-time" },
            revision:{ type:[ "string",
                "null" ],
              format:"date-time" },
            emision:{ type:[ "string",
                "null" ],
              format:"date-time" },
            horaInicio:{ type:"integer",
              format:"int32" },
            horaVencimiento:{ type:"integer",
              format:"int32" },
            efectoInicial:{ type:[ "string",
                "null" ],
              format:"date-time" } },
          additionalProperties:false },
        QuoteDetailDTO:{ type:"object",
          properties:{ producto:{ type:[ "string",
                "null" ] },
            loB:{ type:[ "string",
                "null" ] },
            estado:{ type:"integer",
              format:"int32" },
            subtipoRiesgoCodigoActividad:{ type:"integer",
              format:"int32" },
            subtipoRiesgoDescripcion:{ type:[ "string",
                "null" ] },
            observacionesSuscriptor:{ type:[ "string",
                "null" ] },
            delimitacionTemporal:{ type:[ "string",
                "null" ] },
            meses:{ type:[ "integer",
                "null" ],
              format:"int32" },
            delimitacionGeografica:{ type:[ "string",
                "null" ] },
            coaseguro:{ type:[ "string",
                "null" ] },
            reaseguro:{ type:[ "string",
                "null" ] },
            admonPublica:{ type:[ "string",
                "null" ] },
            ensayoClinico:{ type:[ "string",
                "null" ] },
            colectivo:{ type:[ "string",
                "null" ] },
            polizaEnExceso:{ type:[ "string",
                "null" ] },
            aTermino:{ type:[ "string",
                "null" ] },
            suscriptor:{ type:[ "string",
                "null" ] },
            canal:{ type:[ "string",
                "null" ] },
            legalEntity:{ type:"integer",
              format:"int32" },
            profitCenter:{ type:[ "integer",
                "null" ],
              format:"int32" },
            usuarioComercial:{ type:[ "string",
                "null" ] },
            corredorDescripcion:{ type:[ "string",
                "null" ] },
            corredorCodigo:{ type:[ "integer",
                "null" ],
              format:"int32" },
            oficina:{ type:[ "string",
                "null" ] },
            aseguradoraActual:{ type:[ "string",
                "null" ] },
            historial:{ type:[ "string",
                "null" ] },
            zona:{ type:[ "string",
                "null" ] },
            nroAsegurados:{ type:"integer",
              format:"int32" },
            facturacion:{ type:[ "number",
                "null" ],
              format:"double" },
            franquicia:{ type:[ "string",
                "null" ] },
            nroPlazos:{ type:[ "integer",
                "null" ],
              format:"int32" },
            renovacionTacita:{ type:[ "string",
                "null" ] },
            regularizableIPC:{ type:[ "string",
                "null" ] },
            nroSuplemento:{ type:[ "integer",
                "null" ],
              format:"int32" },
            anularRecibosAnteriores:{ type:[ "string",
                "null" ] },
            listaRecibosAnulados:{ type:[ "string",
                "null" ] },
            fraccionamientoAdaptado:{ type:"boolean" },
            sinFraccionamiento:{ type:"boolean" },
            sinRecibos:{ type:"boolean" },
            corredorOficinaCodigo:{ type:[ "integer",
                "null" ],
              format:"int32" },
            concurso:{ type:[ "string",
                "null" ] },
            enExceso:{ type:[ "number",
                "null" ],
              format:"double" },
            observacionesBroker:{ type:[ "string",
                "null" ] },
            cantidadRiesgos:{ type:"integer",
              format:"int32" },
            noRenovar:{ type:"boolean" },
            motivoRevision:{ type:[ "string",
                "null" ] },
            motivoSuplemento:{ type:[ "string",
                "null" ] },
            descripcionSuplemento:{ type:[ "string",
                "null" ] },
            coberturasOpcionales:{ type:[ "string",
                "null" ] },
            etiquetas:{ type:[ "string",
                "null" ] },
            tipoCot:{ type:[ "string",
                "null" ] },
            tipoPoliza:{ type:[ "string",
                "null" ] },
            industryCodeID:{ type:[ "integer",
                "null" ],
              format:"int32" },
            riesgoNombreFlota:{ type:[ "string",
                "null" ] },
            acuerdoCampania:{ type:[ "string",
                "null" ] },
            fechaRoE:{ type:[ "string",
                "null" ],
              format:"date-time" },
            roE:{ type:[ "number",
                "null" ],
              format:"double" },
            monedaOriginal:{ type:[ "string",
                "null" ] },
            corredorSecundarioCodigo:{ type:[ "integer",
                "null" ],
              format:"int32" },
            corredorSecundarioComision:{ type:[ "number",
                "null" ],
              format:"double" },
            tasa:{ type:[ "number",
                "null" ],
              format:"double" },
            poliza:{ type:[ "integer",
                "null" ],
              format:"int32" },
            polizaStr:{ type:[ "string",
                "null" ] },
            cia:{ type:[ "string",
                "null" ] },
            ciA_Corta:{ type:[ "string",
                "null" ] },
            campana:{ type:[ "string",
                "null" ] },
            paquete:{ type:[ "string",
                "null" ] },
            default_Currency:{ type:[ "string",
                "null" ] },
            productoDescripcion:{ type:[ "string",
                "null" ] },
            gestionCobro:{ type:[ "string",
                "null" ] },
            formaDePago:{ type:[ "string",
                "null" ] },
            fechaSolicitud:{ type:[ "string",
                "null" ],
              format:"date-time" } },
          additionalProperties:false },
        QuoteIdentificationAffinitiesDTO:{ required:[ "quoteId",
            "quoteNumber" ],
          type:"object",
          properties:{ quoteId:{ maximum:2147483647,
              minimum:1,
              type:"integer",
              format:"int32",
              "default":1 },
            quoteNumber:{ maximum:2147483647,
              minimum:0,
              type:"integer",
              format:"int32",
              "default":0 } },
          additionalProperties:false },
        QuoteInitialDataDTO:{ type:"object",
          properties:{ iD_Cot:{ type:"integer",
              format:"int32" },
            n_Cotizacion:{ type:[ "integer",
                "null" ],
              format:"int32" },
            iD_Sup:{ type:[ "integer",
                "null" ],
              format:"int32" },
            iD_Susc:{ type:[ "integer",
                "null" ],
              format:"int32" },
            iD_Marco:{ type:[ "integer",
                "null" ],
              format:"int32" },
            tipoCotizacion:{ $ref:"#/components/schemas/QuoteType" },
            nuevaCotizacion:{ type:"boolean",
              readOnly:true },
            fechas:{ $ref:"#/components/schemas/QuoteDatesDTO" },
            detalle:{ $ref:"#/components/schemas/QuoteDetailDTO" },
            detallePago:{ $ref:"#/components/schemas/PaymentManagementDTO" },
            tomador:{ $ref:"#/components/schemas/PolicyHolderDTO" },
            exposicion:{ $ref:"#/components/schemas/ExpositionDTO" },
            detalleCoaseguro:{ $ref:"#/components/schemas/CoinsuranceDetailDTO" },
            chequeo:{ $ref:"#/components/schemas/ValidationChecksDTO" },
            detallePrima:{ $ref:"#/components/schemas/PremiumDetailDTO" },
            riesgos:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/RiskDTO" } },
            auditoria:{ $ref:"#/components/schemas/AuditDTO" },
            auxiliarData:{ $ref:"#/components/schemas/AuxiliarData" },
            configuracionBranch:{ $ref:"#/components/schemas/UserQuoteAdmIniConfiguration" },
            documentacion:{ $ref:"#/components/schemas/DocumentatinDTO" },
            detallePricing:{ $ref:"#/components/schemas/PricingDetailDTO" },
            questionsAnswers:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Prod_Preguntas" } },
            coveragesAnswers:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/Prod_Coberturas" } } },
          additionalProperties:false },
        QuotePostDTO:{ type:"object",
          properties:{ product:{ type:[ "string",
                "null" ] },
            subRiskType:{ type:"integer",
              format:"int32" },
            startDate:{ type:"string",
              format:"date-time" },
            endDate:{ type:"string",
              format:"date-time" },
            client:{ $ref:"#/components/schemas/ClientPostDTO" },
            paymentManagement:{ $ref:"#/components/schemas/PaymentPostDTO" },
            risks:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/RiskPostDTO" } },
            documentManagement:{ $ref:"#/components/schemas/DocumentManagementPostDTO" } },
          additionalProperties:false },
        QuoteType:{ "enum":[ 0,
            1,
            2,
            3,
            4,
            5,
            6,
            7 ],
          type:"integer",
          format:"int32" },
        QuoteUpdateAuxiliarDTO:{ type:"object",
          properties:{ n_CotizacionOrigen:{ type:[ "integer",
                "null" ],
              format:"int32" },
            estadoCodigo:{ type:[ "string",
                "null" ] },
            modoPagina:{ type:[ "string",
                "null" ] },
            suplementoRenovableVisible:{ type:"boolean" },
            cambioPorComplexPricing:{ type:"boolean" },
            pantallaOrigen:{ type:[ "string",
                "null" ] },
            hostOrigen:{ type:[ "string",
                "null" ] },
            cambioPorTipoCalculoReciboAdaptado:{ type:"boolean" },
            autorizacionesNT:{ type:[ "string",
                "null" ] },
            usuarioAutoriza:{ type:[ "string",
                "null" ] },
            usuarioAutorizaTexto:{ type:[ "string",
                "null" ] },
            motivoSuplementoTexto:{ type:[ "string",
                "null" ] },
            productoDescripcion:{ type:[ "string",
                "null" ] },
            actividadTexto:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        QuoteUpdateDTO:{ type:"object",
          properties:{ idCotizacion:{ type:[ "integer",
                "null" ],
              format:"int32" },
            nroCotizacion:{ type:[ "integer",
                "null" ],
              format:"int32" },
            iD_Sup:{ type:[ "integer",
                "null" ],
              format:"int32" },
            iD_Susc:{ type:[ "integer",
                "null" ],
              format:"int32" },
            iD_Marco:{ type:[ "integer",
                "null" ],
              format:"int32" },
            fechas:{ $ref:"#/components/schemas/QuoteUpdateDatesDTO" },
            detalle:{ $ref:"#/components/schemas/QuoteUpdateDetailDTO" },
            detallePago:{ $ref:"#/components/schemas/PaymentManagementDTO" },
            tomador:{ $ref:"#/components/schemas/PolicyHolderDTO" },
            exposicion:{ $ref:"#/components/schemas/QuoteUpdateExpositionDTO" },
            detalleCoaseguro:{ $ref:"#/components/schemas/CoinsuranceDetailDTO" },
            chequeo:{ $ref:"#/components/schemas/ValidationChecksDTO" },
            auxiliarData:{ $ref:"#/components/schemas/QuoteUpdateAuxiliarDTO" },
            detalleCalculoPrima:{ $ref:"#/components/schemas/QuoteUpdatePremiumDTO" },
            riesgos:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/RiskDTO" } },
            detallePricing:{ $ref:"#/components/schemas/PricingDetailDTO" } },
          additionalProperties:false },
        QuoteUpdateDatesDTO:{ type:"object",
          properties:{ inicioPoliza:{ type:[ "string",
                "null" ],
              format:"date-time" },
            vencimientoPoliza:{ type:[ "string",
                "null" ],
              format:"date-time" },
            inicioSuplemento:{ type:[ "string",
                "null" ],
              format:"date-time" },
            vencimientoSuplemento:{ type:[ "string",
                "null" ],
              format:"date-time" },
            retro:{ type:[ "string",
                "null" ],
              format:"date-time" },
            horaInicio:{ type:"integer",
              format:"int32" },
            horaVencimiento:{ type:"integer",
              format:"int32" },
            efectoInicial:{ type:[ "string",
                "null" ],
              format:"date-time" } },
          additionalProperties:false },
        QuoteUpdateDetailDTO:{ type:"object",
          properties:{ producto:{ type:[ "string",
                "null" ] },
            loB:{ type:[ "string",
                "null" ] },
            subtipoRiesgoCodigoActividad:{ type:"integer",
              format:"int32" },
            observacionesSuscriptor:{ type:[ "string",
                "null" ] },
            delimitacionTemporal:{ type:[ "string",
                "null" ] },
            meses:{ type:[ "integer",
                "null" ],
              format:"int32" },
            delimitacionGeografica:{ type:[ "string",
                "null" ] },
            coaseguro:{ type:[ "string",
                "null" ] },
            reaseguro:{ type:[ "string",
                "null" ] },
            admonPublica:{ type:[ "string",
                "null" ] },
            ensayoClinico:{ type:[ "string",
                "null" ] },
            colectivo:{ type:[ "string",
                "null" ] },
            polizaEnExceso:{ type:[ "string",
                "null" ] },
            aTermino:{ type:[ "string",
                "null" ] },
            suscriptor:{ type:[ "string",
                "null" ] },
            canal:{ type:[ "string",
                "null" ] },
            legalEntity:{ type:"integer",
              format:"int32" },
            profitCenter:{ type:[ "integer",
                "null" ],
              format:"int32" },
            corredorDescripcion:{ type:[ "string",
                "null" ] },
            corredorCodigo:{ type:"integer",
              format:"int32" },
            oficina:{ type:[ "string",
                "null" ] },
            zona:{ type:[ "string",
                "null" ] },
            nroAsegurados:{ type:"integer",
              format:"int32" },
            renovacionTacita:{ type:[ "string",
                "null" ] },
            regularizableIPC:{ type:[ "string",
                "null" ] },
            nroSuplemento:{ type:[ "integer",
                "null" ],
              format:"int32" },
            corredorOficinaCodigo:{ type:[ "integer",
                "null" ],
              format:"int32" },
            concurso:{ type:[ "string",
                "null" ] },
            enExceso:{ type:[ "number",
                "null" ],
              format:"double" },
            observacionesBroker:{ type:[ "string",
                "null" ] },
            cantidadRiesgos:{ type:"integer",
              format:"int32" },
            noRenovar:{ type:"boolean" },
            motivoRevision:{ type:[ "string",
                "null" ] },
            motivoSuplemento:{ type:[ "string",
                "null" ] },
            descripcionSuplemento:{ type:[ "string",
                "null" ] },
            coberturasOpcionales:{ type:[ "string",
                "null" ] },
            etiquetas:{ type:[ "string",
                "null" ] },
            tipoCotizacion:{ type:[ "string",
                "null" ] },
            tipoPoliza:{ type:[ "string",
                "null" ] },
            estadoCodigo:{ type:[ "string",
                "null" ] },
            industryCodeID:{ type:[ "integer",
                "null" ],
              format:"int32" },
            riesgoNombreFlota:{ type:[ "string",
                "null" ] },
            acuerdoCampania:{ type:[ "string",
                "null" ] },
            fechaRoE:{ type:[ "string",
                "null" ],
              format:"date-time" },
            roE:{ type:[ "number",
                "null" ],
              format:"double" },
            monedaOriginal:{ type:[ "string",
                "null" ] },
            corredorSecundarioCodigo:{ type:[ "integer",
                "null" ],
              format:"int32" },
            corredorSecundarioComision:{ type:[ "number",
                "null" ],
              format:"double" },
            usuarioComercial:{ type:[ "string",
                "null" ] },
            tasa:{ type:[ "number",
                "null" ],
              format:"double" },
            poliza:{ type:[ "integer",
                "null" ],
              format:"int32" } },
          additionalProperties:false },
        QuoteUpdateExpositionDTO:{ type:"object",
          properties:{ capital:{ type:[ "number",
                "null" ],
              format:"double" },
            agregado:{ type:[ "number",
                "null" ],
              format:"double" },
            limiteVictima:{ type:[ "number",
                "null" ],
              format:"double" } },
          additionalProperties:false },
        QuoteUpdatePremiumDTO:{ type:"object",
          properties:{ basePrima:{ type:[ "string",
                "null" ] },
            sobrescribirPrimaRenovacion:{ type:"boolean" },
            prima:{ type:[ "number",
                "null" ],
              format:"double" },
            primaRenovacionSuscriptor:{ type:[ "number",
                "null" ],
              format:"double" },
            porcentajeComision:{ type:[ "number",
                "null" ],
              format:"double" },
            porcentajeDescuento:{ type:[ "number",
                "null" ],
              format:"double" },
            recargoEspecial:{ type:[ "number",
                "null" ],
              format:"double" },
            sobrescribirRateIncrease:{ type:"boolean" },
            rateIncreaseSuscriptor:{ type:[ "number",
                "null" ],
              format:"double" },
            suplementoRenovable:{ type:[ "string",
                "null" ] },
            anularRecibosAnteriores:{ type:[ "string",
                "null" ] },
            listaRecibosAnulados:{ type:[ "string",
                "null" ] },
            sinFraccionamiento:{ type:[ "string",
                "null" ] },
            sinRecibos:{ type:[ "string",
                "null" ] },
            fraccionamientoAdaptado:{ type:"boolean" },
            comisionSuplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            primaTarifa:{ type:[ "number",
                "null" ],
              format:"double" },
            primaSuplemento:{ type:[ "number",
                "null" ],
              format:"double" },
            fraccionamientos:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/InstallmentDTO" } } },
          additionalProperties:false },
        ReceiptForAdministrationDTO:{ type:"object",
          properties:{ iD_Recibo:{ type:"integer",
              format:"int32" },
            recibo:{ type:[ "string",
                "null" ] },
            f_Efecto_Rec:{ type:[ "string",
                "null" ] },
            f_Vto_Rec:{ type:[ "string",
                "null" ] },
            periodo_Conta:{ type:"integer",
              format:"int32" },
            corredor:{ type:[ "string",
                "null" ] },
            tipo_Cobro:{ type:[ "string",
                "null" ] },
            estado:{ type:[ "string",
                "null" ] },
            prima_neta:{ type:[ "string",
                "null" ] },
            recargo_Fraccto:{ type:[ "string",
                "null" ] },
            impuestos:{ type:[ "string",
                "null" ] },
            clea:{ type:[ "string",
                "null" ] },
            consorcio:{ type:[ "string",
                "null" ] },
            tributos:{ type:[ "string",
                "null" ] },
            otros_Impuestos:{ type:[ "string",
                "null" ] },
            comision:{ type:[ "string",
                "null" ] },
            prima_Total:{ type:[ "string",
                "null" ] },
            anulado:{ type:"boolean" },
            anulable:{ type:"boolean" } },
          additionalProperties:false },
        ReceiptForAdministrationDTOIEnumerableResponse:{ type:"object",
          properties:{ data:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ReceiptForAdministrationDTO" } },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        ResponseAuthenticationDTO:{ type:"object",
          properties:{ token:{ type:[ "string",
                "null" ] },
            expiration:{ type:"string",
              format:"date-time" } },
          additionalProperties:false },
        ResponseAuthenticationDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/ResponseAuthenticationDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        ResponseCreateRequestUnderwritingDTO:{ type:"object",
          properties:{ quoteID:{ type:"integer",
              format:"int32" },
            quoteNumber:{ type:"integer",
              format:"int32" } },
          additionalProperties:false },
        ResponseCreateRequestUnderwritingDTOResponseUnderwriting:{ type:"object",
          properties:{ isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            data:{ $ref:"#/components/schemas/ResponseCreateRequestUnderwritingDTO" },
            errorModel:{ $ref:"#/components/schemas/ErrorModelUnderwriting" } },
          additionalProperties:false },
        ResponsePremiumUnderwritingDTO:{ type:"object",
          properties:{ premium:{ type:[ "number",
                "null" ],
              format:"double" },
            tariffPremium:{ type:[ "number",
                "null" ],
              format:"double" },
            totalPremium:{ type:[ "number",
                "null" ],
              format:"double" },
            anualPremium:{ type:[ "number",
                "null" ],
              format:"double" },
            renewalPremium:{ type:[ "number",
                "null" ],
              format:"double" },
            tax1:{ type:[ "number",
                "null" ],
              format:"double" },
            tax2:{ type:[ "number",
                "null" ],
              format:"double" },
            tax3:{ type:[ "number",
                "null" ],
              format:"double" },
            tax4:{ type:[ "number",
                "null" ],
              format:"double" },
            otherTaxes:{ type:[ "number",
                "null" ],
              format:"double" },
            commission:{ type:[ "number",
                "null" ],
              format:"double" },
            commissionRate:{ type:[ "number",
                "null" ],
              format:"double" },
            discountRate:{ type:[ "number",
                "null" ],
              format:"double" },
            surchargePercentage:{ type:[ "number",
                "null" ],
              format:"double" },
            surchage:{ type:[ "number",
                "null" ],
              format:"double" },
            specialSurcharge:{ type:[ "number",
                "null" ],
              format:"double" },
            rateIncrease:{ type:[ "number",
                "null" ],
              format:"double" },
            error:{ type:[ "string",
                "null" ] },
            tariffErrors:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        ResponseSaveQuoteUnderwritingDTO:{ type:"object",
          properties:{ quoteID:{ type:[ "string",
                "null" ] },
            quoteNumber:{ type:[ "string",
                "null" ] },
            premiumDetail:{ $ref:"#/components/schemas/ResponsePremiumUnderwritingDTO" } },
          additionalProperties:false },
        ResponseSaveQuoteUnderwritingDTOResponseUnderwriting:{ type:"object",
          properties:{ isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            data:{ $ref:"#/components/schemas/ResponseSaveQuoteUnderwritingDTO" },
            errorModel:{ $ref:"#/components/schemas/ErrorModelUnderwriting" } },
          additionalProperties:false },
        RestoreOptionsDTO:{ type:"object",
          properties:{ backupName:{ type:[ "string",
                "null" ] },
            executeRestore:{ type:"boolean" },
            executeSchema:{ type:"boolean" },
            executeData:{ type:"boolean" },
            executePostDeploy:{ type:"boolean" },
            executeFolderScripts:{ type:"boolean" } },
          additionalProperties:false },
        RiskDTO:{ type:"object",
          properties:{ nroRiesgo:{ type:[ "integer",
                "null" ],
              format:"int32" },
            preguntas:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/QuestionAnswerDTO" } },
            coberturas:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/CoverageAnswerDTO" } } },
          additionalProperties:false },
        RiskPostDTO:{ type:"object",
          properties:{ riskNumber:{ type:[ "integer",
                "null" ],
              format:"int32" },
            questions:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/QuestionPostDTO" } } },
          additionalProperties:false },
        SaveQuoteCoverageAnswerDTO:{ type:"object",
          properties:{ coverageCode:{ type:[ "string",
                "null" ] },
            limitCode:{ type:[ "string",
                "null" ] },
            value:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        SaveQuoteDTO:{ type:"object",
          properties:{ quoteID:{ type:[ "integer",
                "null" ],
              format:"int32" },
            quoteNumber:{ type:[ "integer",
                "null" ],
              format:"int32" },
            dates:{ $ref:"#/components/schemas/SaveQuoteDatesDTO" },
            detail:{ $ref:"#/components/schemas/SaveQuoteDetailDTO" },
            paymentDetail:{ $ref:"#/components/schemas/SaveQuotePaymentDTO" },
            policyHolder:{ $ref:"#/components/schemas/SaveQuotePolicyholderDTO" },
            exposition:{ $ref:"#/components/schemas/SaveQuoteExpositionDTO" },
            premiumDetail:{ $ref:"#/components/schemas/SaveQuotePremiumDTO" },
            risks:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/SaveQuoteRiskDTO" } } },
          additionalProperties:false },
        SaveQuoteDTOResponseUnderwriting:{ type:"object",
          properties:{ isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            data:{ $ref:"#/components/schemas/SaveQuoteDTO" },
            errorModel:{ $ref:"#/components/schemas/ErrorModelUnderwriting" } },
          additionalProperties:false },
        SaveQuoteDatesDTO:{ type:"object",
          properties:{ request:{ type:[ "string",
                "null" ],
              format:"date-time" },
            quote:{ type:[ "string",
                "null" ],
              format:"date-time" },
            policyStart:{ type:[ "string",
                "null" ],
              format:"date-time" },
            policyEnd:{ type:[ "string",
                "null" ],
              format:"date-time" },
            retro:{ type:[ "string",
                "null" ],
              format:"date-time" } },
          additionalProperties:false },
        SaveQuoteDetailDTO:{ type:"object",
          properties:{ productCode:{ type:[ "string",
                "null" ] },
            loB:{ type:[ "string",
                "null" ] },
            stateCode:{ type:"integer",
              format:"int32" },
            riskSubtypeActivityCode:{ type:"integer",
              format:"int32" },
            temporalLimits:{ type:[ "string",
                "null" ] },
            months:{ type:[ "integer",
                "null" ],
              format:"int32" },
            geographicalLimits:{ type:[ "string",
                "null" ] },
            coinsurance:{ type:[ "string",
                "null" ] },
            reinsurance:{ type:[ "string",
                "null" ] },
            isPublicTender:{ type:[ "string",
                "null" ] },
            publicTender:{ type:[ "string",
                "null" ] },
            medicalTrial:{ type:[ "string",
                "null" ] },
            groupPolicy:{ type:[ "string",
                "null" ] },
            excessPolicy:{ type:[ "string",
                "null" ] },
            toTerm:{ type:[ "string",
                "null" ] },
            underwriter:{ type:[ "string",
                "null" ] },
            canal:{ type:[ "string",
                "null" ] },
            legalEntity:{ type:"integer",
              format:"int32" },
            profitCenter:{ type:[ "integer",
                "null" ],
              format:"int32" },
            brokerCode:{ type:[ "integer",
                "null" ],
              format:"int32" },
            office:{ type:[ "string",
                "null" ] },
            numberInsured:{ type:"integer",
              format:"int32" },
            numberInstallments:{ type:[ "integer",
                "null" ],
              format:"int32" },
            tacitalRenewal:{ type:[ "string",
                "null" ] },
            regularisedAccordingCPI:{ type:[ "string",
                "null" ] },
            endorsementNumber:{ type:[ "integer",
                "null" ],
              format:"int32" },
            officeBrokerCode:{ type:[ "integer",
                "null" ],
              format:"int32" },
            inExcessOf:{ type:[ "number",
                "null" ],
              format:"double" },
            numberOfRisks:{ type:"integer",
              format:"int32" },
            reviewAtRenewal:{ type:"boolean" },
            reasonForReview:{ type:[ "string",
                "null" ] },
            optionalCoverages:{ type:[ "string",
                "null" ] },
            industryCodeID:{ type:[ "integer",
                "null" ],
              format:"int32" },
            originalCurrency:{ type:[ "string",
                "null" ] },
            requestDate:{ type:[ "string",
                "null" ],
              format:"date-time" } },
          additionalProperties:false },
        SaveQuoteExpositionDTO:{ type:"object",
          properties:{ perClaimLimit:{ type:[ "number",
                "null" ],
              format:"double" },
            aggregateLimit:{ type:[ "number",
                "null" ],
              format:"double" },
            limitPerVictim:{ type:[ "number",
                "null" ],
              format:"double" } },
          additionalProperties:false },
        SaveQuotePaymentDTO:{ type:"object",
          properties:{ collectionType:{ type:[ "string",
                "null" ] },
            paymentFrecuency:{ type:[ "string",
                "null" ] },
            iban:{ type:[ "string",
                "null" ] },
            ccc:{ type:[ "string",
                "null" ] },
            numberInstallments:{ type:[ "integer",
                "null" ],
              format:"int32" } },
          additionalProperties:false },
        SaveQuotePolicyholderDTO:{ type:"object",
          properties:{ policyholder:{ type:[ "string",
                "null" ] },
            nif:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] },
            phone:{ type:[ "string",
                "null" ] },
            countryID:{ type:[ "integer",
                "null" ],
              format:"int32" },
            province:{ type:[ "string",
                "null" ] },
            town:{ type:[ "string",
                "null" ] },
            street:{ type:[ "string",
                "null" ] },
            postalCode:{ type:[ "string",
                "null" ] },
            secondAddress:{ $ref:"#/components/schemas/SaveQuoteSecondAddressDTO" } },
          additionalProperties:false },
        SaveQuotePremiumDTO:{ type:"object",
          properties:{ premium:{ type:[ "number",
                "null" ],
              format:"double" },
            annualTariffPremium:{ type:[ "number",
                "null" ],
              format:"double" },
            totalPremium:{ type:[ "number",
                "null" ],
              format:"double" },
            proratedTariffPremium:{ type:[ "number",
                "null" ],
              format:"double" },
            tax1:{ type:[ "number",
                "null" ],
              format:"double" },
            tax2:{ type:[ "number",
                "null" ],
              format:"double" },
            tax3:{ type:[ "number",
                "null" ],
              format:"double" },
            tax4:{ type:[ "number",
                "null" ],
              format:"double" },
            otherTaxes:{ type:[ "number",
                "null" ],
              format:"double" },
            comission:{ type:[ "number",
                "null" ],
              format:"double" },
            commissionPercentage:{ type:[ "number",
                "null" ],
              format:"double" } },
          additionalProperties:false },
        SaveQuoteQuestionAnswerDTO:{ type:"object",
          properties:{ questionID:{ type:[ "string",
                "null" ] },
            answer:{ type:[ "string",
                "null" ] },
            rowNumber:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        SaveQuoteResponseDTO:{ type:"object",
          properties:{ idCotizacion:{ type:[ "string",
                "null" ] },
            nroCotizacion:{ type:[ "string",
                "null" ] },
            validaciones:{ $ref:"#/components/schemas/QuoteAlertsDTO" },
            urlRedirect:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        SaveQuoteResponseDTOResponse:{ type:"object",
          properties:{ data:{ $ref:"#/components/schemas/SaveQuoteResponseDTO" },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        SaveQuoteRiskDTO:{ type:"object",
          properties:{ riskNumber:{ type:[ "integer",
                "null" ],
              format:"int32" },
            questions:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/SaveQuoteQuestionAnswerDTO" } },
            coverages:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/SaveQuoteCoverageAnswerDTO" } } },
          additionalProperties:false },
        SaveQuoteSecondAddressDTO:{ type:"object",
          properties:{ hasFiscalAddress:{ type:"boolean" },
            addAddress:{ type:"boolean" },
            addressType:{ type:[ "string",
                "null" ] },
            street:{ type:[ "string",
                "null" ] },
            town:{ type:[ "string",
                "null" ] },
            postalCode:{ type:[ "string",
                "null" ] },
            province:{ type:[ "string",
                "null" ] },
            countryID:{ type:[ "integer",
                "null" ],
              format:"int32" },
            nameAddress:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        Save_Mail_ServicesDTO:{ type:"object",
          properties:{ action:{ type:[ "string",
                "null" ] },
            tipo:{ type:[ "string",
                "null" ] },
            patron:{ type:[ "string",
                "null" ] },
            suscriptor:{ type:[ "string",
                "null" ] },
            tramitador:{ type:[ "string",
                "null" ] },
            lob:{ type:[ "string",
                "null" ] },
            cliente:{ type:[ "string",
                "null" ] },
            id_cot:{ type:[ "string",
                "null" ] },
            poliza:{ type:[ "string",
                "null" ] },
            id_sin:{ type:[ "string",
                "null" ] },
            mensaje:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        SecondAddressDTO:{ type:"object",
          properties:{ tieneDireccionFiscal:{ type:"boolean" },
            agregarDireccion:{ type:"boolean" },
            idTipoDireccion:{ type:[ "string",
                "null" ] },
            calle:{ type:[ "string",
                "null" ] },
            localidad:{ type:[ "string",
                "null" ] },
            codPostal:{ type:[ "string",
                "null" ] },
            provincia:{ type:[ "string",
                "null" ] },
            idPais:{ type:[ "integer",
                "null" ],
              format:"int32" },
            nombre:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        SelectListItem:{ type:"object",
          properties:{ text:{ type:[ "string",
                "null" ] },
            value:{ type:[ "string",
                "null" ] },
            orden:{ type:"integer",
              format:"int32" } },
          additionalProperties:false },
        SelectListItemDTO:{ type:"object",
          properties:{ text:{ type:[ "string",
                "null" ] },
            value:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        StringIEnumerableResponse:{ type:"object",
          properties:{ data:{ type:[ "array",
                "null" ],
              items:{ type:"string" } },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        StringResponse:{ type:"object",
          properties:{ data:{ type:[ "string",
                "null" ] },
            isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            errorModel:{ $ref:"#/components/schemas/ErrorModel" } },
          additionalProperties:false },
        SubRiskTypeDTO:{ type:"object",
          properties:{ subRiskType:{ type:"integer",
              format:"int32" },
            description:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        TranslatedString:{ type:"object",
          properties:{ originalValue:{ type:[ "string",
                "null" ] },
            translation:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        UpdateDigitalSignResponseDTO:{ type:"object",
          properties:{ signatureStatus:{ type:"integer",
              format:"int32" },
            signatureStatusDescription:{ type:[ "string",
                "null" ],
              readOnly:true },
            brokerStatus:{ type:"integer",
              format:"int32" },
            brokerStatusDescription:{ type:[ "string",
                "null" ],
              readOnly:true } },
          additionalProperties:false },
        UpdateDigitalSignResponseDTOResponseAffinities:{ type:"object",
          properties:{ isSuccess:{ type:"boolean" },
            message:{ type:[ "string",
                "null" ] },
            data:{ $ref:"#/components/schemas/UpdateDigitalSignResponseDTO" },
            errorModel:{ $ref:"#/components/schemas/ErrorModelAffinities" } },
          additionalProperties:false },
        UserQuoteAdmIniConfiguration:{ type:"object",
          properties:{ branch:{ type:[ "string",
                "null" ] },
            segundaDireccion:{ type:"boolean" },
            industryCode:{ type:"boolean" },
            comisionCero:{ type:"boolean" },
            alertaSuplementos:{ type:"boolean" },
            controlImpuestosSuplemento:{ type:"boolean" },
            controlImpuestosSuplementoDiferencia:{ type:[ "number",
                "null" ],
              format:"double" },
            comprobarIban:{ type:"boolean" },
            disableEnterCif:{ type:"boolean" },
            hideProvince:{ type:"boolean" },
            showMultipleDocs:{ type:"boolean" },
            pricing_PremiumTechnical:{ type:"boolean" },
            pricing_ExpectedLoss:{ type:"boolean" },
            pricing_PremiumTarget:{ type:"boolean" },
            showProposals:{ type:"boolean" },
            docDefault_COT:{ type:[ "string",
                "null" ] },
            docDefault_COT_V:{ type:[ "string",
                "null" ] },
            docDefault_POL:{ type:[ "string",
                "null" ] },
            docDefault_POL_V:{ type:[ "string",
                "null" ] },
            docDefault_REN:{ type:[ "string",
                "null" ] },
            docDefault_REN_V:{ type:[ "string",
                "null" ] },
            docDefault_SUP:{ type:[ "string",
                "null" ] },
            docDefault_SUP_V:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        ValidationChecksDTO:{ type:"object",
          properties:{ revisionFechas:{ type:"boolean" },
            revisionComision:{ type:"boolean" },
            revisionPrimas:{ type:"boolean" },
            revisionTasa:{ type:"boolean" } },
          additionalProperties:false },
        WarningMessage:{ type:"object",
          properties:{ titleAviso:{ type:[ "string",
                "null" ] },
            title:{ $ref:"#/components/schemas/TranslatedString" },
            titleTranslated:{ type:[ "string",
                "null" ] },
            messages:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/ErrorMessage" } } },
          additionalProperties:false } },
      securitySchemes:{ Bearer:{ type:"apiKey",
          name:"Authorization",
          "in":"header" } } },
    security:[ { Bearer:[  ] } ],
    "x-ext-urls":{} } }